/**
 * Arabic (remediation pass 12). Written by the build team and **pending
 * Algihaz's review** (OPEN_QUESTIONS Q30). The English text is the key; a
 * string with no entry shows in English. Correct a translation here — it is
 * data, and `i18n.test.ts` in the web app checks every screen string has one.
 */
export const AR_CATALOGUE = {
    " (approved)": " (معتمد)",
    " (checked {0})": " (تم التحقق في {0})",
    " (required)": " (مطلوب)",
    " (sent when approved)": " (يُرسل عند الاعتماد)",
    " It runs as the person who switched it on, and stops if they can no longer export.": " يعمل باسم الشخص الذي فعّله، ويتوقف إذا لم يعد بإمكانه التصدير.",
    " The team is set before the opening meeting.": " يُحدَّد الفريق قبل الاجتماع الافتتاحي.",
    " This list also sends to {0} person(s) chosen by account.": " ترسل هذه القائمة أيضًا إلى {0} شخص/أشخاص محددين بالحساب.",
    " and sending now.": " وجارٍ إرسالها الآن.",
    " at {0}": " في {0}",
    " categories": " فئات",
    " category": " فئة",
    " on {0}": " في {0}",
    " to {0}": " إلى {0}",
    " · always delivered": " · يُسلَّم دائمًا",
    " · clause {0}": " · البند {0}",
    " · dry run, nothing changed": " · تشغيل تجريبي، لم يتغير شيء",
    " · ended early": " · انتهى مبكرًا",
    " · extension requested to ": " · طُلب التمديد إلى ",
    " · finished": " · انتهى",
    " · mapping v{0}": " · التعيين الإصدار {0}",
    " · sandbox: dry runs only": " · بيئة تجريبية: تشغيل تجريبي فقط",
    " · target {0}": " · المستهدف {0}",
    " — follow-up (last one not effective)": " — متابعة (الإجراء السابق لم يكن فعالًا)",
    " — no access": " — لا صلاحية",
    " — not approved, so the date stands": " — لم يُعتمد، لذا يبقى التاريخ كما هو",
    " — not set up on this server": " — غير مُعدّ على هذا الخادم",
    " — they send when you have a signal and QMS360 is open. Keep it open, or open it again later.": " — تُرسل عندما تتوفر إشارة ويكون QMS360 مفتوحًا. أبقه مفتوحًا، أو افتحه مرة أخرى لاحقًا.",
    "% closure-rate target.": "٪ مستهدف نسبة الإغلاق.",
    "(location not captured:": "(لم يُلتقط الموقع:",
    "). Temporary password — shown once. They must choose a new one when they sign in.": "). كلمة مرور مؤقتة — تُعرض مرة واحدة. يجب عليه اختيار كلمة جديدة عند تسجيل الدخول.",
    ", and {0} open session{1} signed out.": "، وتم تسجيل الخروج من {0} جلسة مفتوحة{1}.",
    ", marked [SANDBOX].": "، مع وسم [SANDBOX].",
    ", not the time you write this up. Minutes are typed afterwards, and a wrong time is a wrong fact in an audit record.": "، وليس وقت كتابة المحضر. تُكتب المحاضر لاحقًا، والوقت الخاطئ حقيقة خاطئة في سجل التدقيق.",
    ", row {0}": "، الصف {0}",
    ", which was not effective.": "، الذي لم يكن فعالًا.",
    "-second limit.": " ثانية كحد أقصى.",
    ". A question left blank is not counted as zero.": ". السؤال المتروك فارغًا لا يُحتسب صفرًا.",
    ". An owner cannot prepare against blanks.": ". لا يمكن للمالك الاستعداد مقابل حقول فارغة.",
    ". Email goes through the connection in the": ". يُرسل البريد الإلكتروني عبر الاتصال في",
    ". Holidays are excluded from every clock:": ". تُستثنى العطل من كل المؤقتات:",
    ". No Guest Auditor can read it any more: their access ended when it closed.": ". لم يعد بإمكان أي مدقق زائر قراءته: انتهت صلاحيته عند إغلاقه.",
    ". Nothing in this document is generated text — every line above is something somebody recorded.": ". لا يوجد في هذا المستند نص مُولَّد — كل سطر أعلاه سجّله شخص ما.",
    "0–15 days": "0–15 يومًا",
    "15–45 days": "15–45 يومًا",
    "; until one is set up, messages wait in its outbox, marked not sent. Every run is on the": "؛ وحتى يتم إعداده، تنتظر الرسائل في صندوق الصادر مع وسمها بأنها غير مرسلة. كل تشغيل مسجّل في",
    "A Guest Auditor can only read the audit they are invited to.": "المدقق الزائر لا يستطيع إلا قراءة التدقيق المدعو إليه.",
    "A custom role is built from the same permissions as the shipped roles and nothing else, so it is checked exactly the way they are.": "الدور المخصص يُبنى من الصلاحيات نفسها التي تتكون منها الأدوار المرفقة ولا شيء غيرها، لذا يُتحقق منه بالطريقة نفسها تمامًا.",
    "A delegation hands your application roles to a colleague between two dates — for leave, say. Everything they do with it is recorded as done on your behalf.": "التفويض يسلّم أدوارك في التطبيق إلى زميل بين تاريخين — أثناء الإجازة مثلًا. كل ما يفعله به يُسجَّل على أنه تم نيابة عنك.",
    "A delegation must end after it begins.": "يجب أن ينتهي التفويض بعد بدايته.",
    "A dry run reads the feed and reports what it would change, and changes nothing. With sandbox on, every run is a dry run.": "التشغيل التجريبي يقرأ المصدر ويبيّن ما كان سيغيّره، ولا يغيّر شيئًا. عند تفعيل البيئة التجريبية، يكون كل تشغيل تجريبيًا.",
    "A generated document is opened from the report it belongs to, not as a file.": "المستند المُنشأ يُفتح من التقرير الذي ينتمي إليه، لا كملف.",
    "A key is stored but this server can no longer read it — enter it again.": "يوجد مفتاح مخزَّن لكن هذا الخادم لم يعد قادرًا على قراءته — أدخله مرة أخرى.",
    "A list switched on needs at least one recipient.": "القائمة المفعّلة تحتاج إلى مستلم واحد على الأقل.",
    "A non-conformity needs a risk level — it is what decides the priority and the SLA.": "عدم المطابقة يحتاج إلى مستوى مخاطر — فهو ما يحدد الأولوية واتفاقية مستوى الخدمة.",
    "A person decides.": "يقرر شخص.",
    "A provisional report cannot be issued. Close the audit first.": "لا يمكن إصدار تقرير مؤقت. أغلق التدقيق أولًا.",
    "A record with no identifier": "سجل بلا مُعرِّف",
    "A refresh token is required.": "رمز التحديث مطلوب.",
    "A report cannot be approved by the person who submitted it.": "لا يمكن أن يعتمد التقرير الشخصُ الذي قدّمه.",
    "A revocation takes effect on the person’s": "يسري الإلغاء عند",
    "A rewrite needs a connection. Your own wording works offline.": "إعادة الصياغة تحتاج إلى اتصال. صياغتك الخاصة تعمل دون اتصال.",
    "A role granting nothing would be indistinguishable from not having it.": "دور لا يمنح شيئًا لا يمكن تمييزه عن عدم امتلاكه.",
    "A scheduled run acts as whoever switched the sync on, and stops if they lose the authority to change project master data. Runs, errors and the field mapping are in the": "التشغيل المجدول يعمل باسم من فعّل المزامنة، ويتوقف إذا فقد صلاحية تغيير البيانات الرئيسية للمشاريع. التشغيلات والأخطاء وتعيين الحقول موجودة في",
    "A short name a colleague would search for": "اسم قصير يبحث عنه الزميل",
    "A slower answer is dropped and the form carries on by hand.": "يُتجاهل الرد الأبطأ ويستمر النموذج يدويًا.",
    "A view of the audit log, not a second copy of it — there is one history in QMS360 and this is it, filtered to access changes.": "عرض لسجل التدقيق وليس نسخة ثانية منه — يوجد في QMS360 سجل واحد وهذا هو، مصفّى على تغييرات الصلاحيات.",
    "A working week needs at least one working day, or no SLA clock can ever elapse.": "أسبوع العمل يحتاج إلى يوم عمل واحد على الأقل، وإلا فلن ينقضي أي مؤقت لاتفاقية مستوى الخدمة.",
    "AI Settings & Controls": "إعدادات الذكاء الاصطناعي وضوابطه",
    "AI activity": "نشاط الذكاء الاصطناعي",
    "AI assistance: the draft was": "مساعدة الذكاء الاصطناعي: المسودة",
    "AI draft": "مسودة الذكاء الاصطناعي",
    "AI draft applied below.": "طُبّقت مسودة الذكاء الاصطناعي أدناه.",
    "AI draft applied.": "طُبّقت مسودة الذكاء الاصطناعي.",
    "AI draft — review before using": "مسودة ذكاء اصطناعي — راجعها قبل الاستخدام",
    "AI fills in what your sentence states. You check every field before saving. Nothing is saved until you save.": "يملأ الذكاء الاصطناعي ما تذكره جملتك. تتحقق أنت من كل حقل قبل الحفظ. لا يُحفظ شيء حتى تحفظ.",
    "AI only ever suggests. Nothing it writes reaches a record until someone accepts or edits it, and that choice is recorded. This cannot be switched off.": "الذكاء الاصطناعي يقترح فقط. لا يصل شيء مما يكتبه إلى السجل حتى يقبله شخص أو يعدّله، ويُسجَّل ذلك الاختيار. لا يمكن إيقاف ذلك.",
    "AI rephrasing becomes available once this lesson is saved.": "تتوفر إعادة الصياغة بالذكاء الاصطناعي بعد حفظ هذا الدرس.",
    "AI suggestion": "اقتراح الذكاء الاصطناعي",
    "AI usage and governance": "استخدام الذكاء الاصطناعي وحوكمته",
    "API keys and prices": "مفاتيح الواجهة البرمجية والأسعار",
    "API keys and prices are shared by all three applications, so changing them needs AI settings authority in all three.": "مفاتيح الواجهة البرمجية والأسعار مشتركة بين التطبيقات الثلاثة، لذا يحتاج تغييرها إلى صلاحية إعدادات الذكاء الاصطناعي في الثلاثة.",
    "Accept": "قبول",
    "Account created for": "تم إنشاء حساب لـ",
    "Account is no longer active.": "الحساب لم يعد نشطًا.",
    "Across the applications": "عبر التطبيقات",
    "Acting for you": "ينوب عنك",
    "Action": "الإجراء",
    "Add": "إضافة",
    "Add a question to {0}": "إضافة سؤال إلى {0}",
    "Add a response": "إضافة رد",
    "Add response": "إضافة رد",
    "Add target": "إضافة مستهدف",
    "Add the question": "إضافة السؤال",
    "Administering access is a distinct authority from configuring master data, held by administrators only.": "إدارة الصلاحيات سلطة مستقلة عن إعداد البيانات الرئيسية، ولا يملكها إلا المسؤولون.",
    "After": "بعد",
    "Ageing bands (days, ascending)": "فئات التقادم (بالأيام، تصاعديًا)",
    "Algihaz have confirmed these numbers — remove the provisional badge": "أكّدت Algihaz هذه الأرقام — أزل شارة المؤقت",
    "All": "الكل",
    "All I can see": "كل ما يمكنني رؤيته",
    "All categories": "كل الفئات",
    "All changes are synced.": "تمت مزامنة كل التغييرات.",
    "All groups": "كل المجموعات",
    "All my projects": "كل مشاريعي",
    "All projects": "كل المشاريع",
    "All reports": "كل التقارير",
    "All three applications at a glance, within what your role can see. Each figure opens the application behind it.": "التطبيقات الثلاثة في لمحة، ضمن ما يسمح دورك برؤيته. كل رقم يفتح التطبيق الذي يقف خلفه.",
    "All three applications send this, so changing it needs configuration authority in all three.": "التطبيقات الثلاثة ترسل هذا، لذا يحتاج تغييره إلى صلاحية الإعداد في الثلاثة.",
    "Also send me a test message": "أرسل لي أيضًا رسالة اختبار",
    "Always on": "مفعّل دائمًا",
    "An administrator reset your password. Enter the temporary password you were given, then choose one only you know. Nothing else is available until you do.": "أعاد مسؤول تعيين كلمة مرورك. أدخل كلمة المرور المؤقتة التي أُعطيت لك، ثم اختر كلمة لا يعرفها سواك. لا يتاح شيء آخر حتى تفعل ذلك.",
    "An external auditor invited here can read this audit — and nothing else — until the end date, or until the audit closes. Every page they open is recorded. Their account is created in Users & roles.": "يمكن للمدقق الخارجي المدعو هنا قراءة هذا التدقيق — ولا شيء غيره — حتى تاريخ الانتهاء أو حتى إغلاق التدقيق. تُسجَّل كل صفحة يفتحها. يُنشأ حسابه في المستخدمون والأدوار.",
    "Annual Audit Schedule": "جدول التدقيق السنوي",
    "Annual Schedule Approval": "اعتماد الجدول السنوي",
    "Annual audit programme approved": "اعتُمد برنامج التدقيق السنوي",
    "Annual audit schedule": "جدول التدقيق السنوي",
    "Annual programme": "البرنامج السنوي",
    "Annual schedule": "الجدول السنوي",
    "Anonymous respondent": "مستجيب مجهول",
    "Answered": "تمت الإجابة",
    "Any": "أي",
    "Application": "التطبيق",
    "Application sections": "أقسام التطبيق",
    "Applied since": "مُطبَّق منذ",
    "Applied.": "تم التطبيق.",
    "Apply": "تطبيق",
    "Apply these changes": "تطبيق هذه التغييرات",
    "Approval": "الاعتماد",
    "Approval Inbox": "صندوق الاعتمادات",
    "Approval inbox": "صندوق الاعتمادات",
    "Approval memo": "مذكرة الاعتماد",
    "Approvals": "الاعتمادات",
    "Approve": "اعتماد",
    "Approve / Reject": "اعتماد / رفض",
    "Approve or send back the annual audit programme.": "اعتمد برنامج التدقيق السنوي أو أعده للمراجعة.",
    "Approve the extension": "اعتماد التمديد",
    "Approved": "معتمد",
    "Approved by": "اعتمده",
    "Approver / Reviewer": "المعتمِد / المراجِع",
    "Approver Inbox": "صندوق المعتمِد",
    "Arabic, optional": "بالعربية، اختياري",
    "Archive": "أرشفة",
    "Arrow": "سهم",
    "As of": "اعتبارًا من",
    "As saved on the server; unsaved changes on this device are not in it.": "كما هو محفوظ على الخادم؛ التغييرات غير المحفوظة على هذا الجهاز ليست فيه.",
    "Asked": "سُئل",
    "At (organisation time)": "في (توقيت المنظمة)",
    "At least 12. Leave empty to keep every entry online.": "12 على الأقل. اتركه فارغًا لإبقاء كل سجل متاحًا.",
    "At least {0} characters.": "{0} أحرف على الأقل.",
    "Attach a photo or PDF": "إرفاق صورة أو ملف PDF",
    "Attendees": "الحضور",
    "Audit": "التدقيق",
    "Audit & Compliance Log": "سجل التدقيق والامتثال",
    "Audit & Compliance Log extract": "مستخرج سجل التدقيق والامتثال",
    "Audit Dashboard": "لوحة التدقيق",
    "Audit Execution": "تنفيذ التدقيق",
    "Audit Plans": "خطط التدقيق",
    "Audit Program Manager": "مدير برنامج التدقيق",
    "Audit Team Lead / Auditor": "قائد فريق التدقيق / المدقق",
    "Audit ageing": "تقادم التدقيق",
    "Audit dashboard": "لوحة التدقيق",
    "Audit log retention": "مدة الاحتفاظ بسجل التدقيق",
    "Audit plan": "خطة التدقيق",
    "Audit plans": "خطط التدقيق",
    "Audit report preview": "معاينة تقرير التدقيق",
    "Audit schedule": "جدول التدقيق",
    "Audit status": "حالة التدقيق",
    "Audits": "عمليات التدقيق",
    "Audits closed": "عمليات تدقيق مغلقة",
    "Audits planned": "عمليات التدقيق المخططة",
    "Audits you are invited to": "عمليات التدقيق المدعو إليها",
    "Authentication is required.": "يلزم تسجيل الدخول.",
    "Average (1–5)": "المتوسط (1–5)",
    "Average attendance": "متوسط الحضور",
    "Average index": "متوسط المؤشر",
    "Average of all questions": "متوسط كل الأسئلة",
    "Average ratings per project per month, so the trend is visible alongside the level.": "متوسط التقييمات لكل مشروع لكل شهر، ليظهر الاتجاه إلى جانب المستوى.",
    "Average review days": "متوسط أيام المراجعة",
    "Avg review days": "متوسط أيام المراجعة",
    "BU / Project Head": "رئيس وحدة الأعمال / المشروع",
    "Back to default": "العودة إلى الافتراضي",
    "Back to the audit": "العودة إلى التدقيق",
    "Balanced.": "متوازن.",
    "Band": "الفئة",
    "Before": "قبل",
    "Before this can be shared it still needs": "قبل مشاركتها ما زالت تحتاج إلى",
    "Before you rely on this report": "قبل الاعتماد على هذا التقرير",
    "Being verified": "قيد التحقق",
    "Between": "بين",
    "Both are recorded by the device. Neither can be typed, and a location that could not be obtained is recorded as such rather than left blank.": "كلاهما يسجله الجهاز. لا يمكن كتابة أي منهما، والموقع الذي تعذّر الحصول عليه يُسجَّل على هذا النحو بدلًا من تركه فارغًا.",
    "Breached": "تم تجاوزه",
    "Breadcrumb": "مسار التنقل",
    "Brief": "الموجز",
    "Brief saved.": "تم حفظ الموجز.",
    "Build the annual audit programme and submit it for approval.": "أعدّ برنامج التدقيق السنوي وقدّمه للاعتماد.",
    "Build the annual programme, plan and run an audit, classify what you find, and track each corrective action through to verified closure.": "أعدّ البرنامج السنوي، وخطط للتدقيق ونفّذه، وصنّف ما تجده، وتابع كل إجراء تصحيحي حتى الإغلاق المُتحقَّق منه.",
    "Built in": "مدمج",
    "Built-in sample (for trying it out)": "عيّنة مدمجة (للتجربة)",
    "Bulk role assignment": "تعيين الأدوار بالجملة",
    "Business unit code": "رمز وحدة الأعمال",
    "Business units": "وحدات الأعمال",
    "Business units, disciplines, categorisation and targets. Projects and username associations are synced and read-only.": "وحدات الأعمال والتخصصات والتصنيف والمستهدفات. المشاريع وارتباطات أسماء المستخدمين متزامنة وللقراءة فقط.",
    "By category and impact": "حسب الفئة والأثر",
    "By classification": "حسب التصنيف",
    "By month": "حسب الشهر",
    "By status": "حسب الحالة",
    "CAR": "تقرير الإجراء التصحيحي",
    "CSV": "CSV",
    "Came in from a device": "ورد من جهاز",
    "Can use:": "يمكن استخدامه:",
    "Cancel": "إلغاء",
    "Capture a lesson on site, with or without a signal. Anything recorded offline syncs when you reconnect.": "التقط درسًا في الموقع، مع إشارة أو بدونها. كل ما يُسجَّل دون اتصال يُزامَن عند إعادة الاتصال.",
    "Captured": "تاريخ الالتقاط",
    "Captured at": "وقت الالتقاط",
    "Carried out": "نُفّذ",
    "Categorisation": "التصنيف",
    "Categorisation & risk": "التصنيف والمخاطر",
    "Category": "الفئة",
    "Change history": "سجل التغييرات",
    "Change password": "تغيير كلمة المرور",
    "Change scope": "تغيير النطاق",
    "Change the scope of {0}": "تغيير نطاق {0}",
    "Changes that need reconciling": "تغييرات تحتاج إلى تسوية",
    "Changing keys and prices needs AI settings authority in all three applications.": "تغيير المفاتيح والأسعار يحتاج إلى صلاحية إعدادات الذكاء الاصطناعي في التطبيقات الثلاثة.",
    "Changing this needs configuration authority in the application that sends it.": "تغيير هذا يحتاج إلى صلاحية الإعداد في التطبيق الذي يرسله.",
    "Channel": "القناة",
    "Check every field — it is the AI’s reading of your sentence, and you are the one who saves it.": "تحقق من كل حقل — إنه قراءة الذكاء الاصطناعي لجملتك، وأنت من يحفظه.",
    "Check the AI settings.": "تحقق من إعدادات الذكاء الاصطناعي.",
    "Check the brief.": "تحقق من الموجز.",
    "Check the connection settings.": "تحقق من إعدادات الاتصال.",
    "Check the dashboard filters.": "تحقق من عوامل تصفية لوحة المتابعة.",
    "Check the date range.": "تحقق من النطاق التاريخي.",
    "Check the details you entered.": "تحقق من البيانات التي أدخلتها.",
    "Check the disposition.": "تحقق من القرار.",
    "Check the field.": "تحقق من الحقل.",
    "Check the figures you entered.": "تحقق من الأرقام التي أدخلتها.",
    "Check the filters.": "تحقق من عوامل التصفية.",
    "Check the key.": "تحقق من المفتاح.",
    "Check the lesson details.": "تحقق من تفاصيل الدرس.",
    "Check the log entry.": "تحقق من السجل.",
    "Check the mapping.": "تحقق من التعيين.",
    "Check the marks on the photo.": "تحقق من العلامات على الصورة.",
    "Check the message.": "تحقق من الرسالة.",
    "Check the passwords you entered.": "تحقق من كلمات المرور التي أدخلتها.",
    "Check the photo.": "تحقق من الصورة.",
    "Check the preferences.": "تحقق من التفضيلات.",
    "Check the price.": "تحقق من السعر.",
    "Check the project and period.": "تحقق من المشروع والفترة.",
    "Check the report filters.": "تحقق من عوامل تصفية التقرير.",
    "Check the run options.": "تحقق من خيارات التشغيل.",
    "Check the setup details.": "تحقق من بيانات الإعداد.",
    "Check the signature image.": "تحقق من صورة التوقيع.",
    "Check the survey response.": "تحقق من رد الاستبيان.",
    "Check the sync batch.": "تحقق من دفعة المزامنة.",
    "Check the test options.": "تحقق من خيارات الاختبار.",
    "Check the upload.": "تحقق من الملف المرفوع.",
    "Check your connection and try again.": "تحقق من اتصالك وحاول مرة أخرى.",
    "Checking this device…": "جارٍ فحص هذا الجهاز…",
    "Checklist": "قائمة التحقق",
    "Checklist Templates": "قوالب قوائم التحقق",
    "Checklist answer": "إجابة قائمة التحقق",
    "Checklist answers": "إجابات قائمة التحقق",
    "Checklist item": "بند قائمة التحقق",
    "Checklist template": "قالب قائمة التحقق",
    "Checklist templates": "قوالب قوائم التحقق",
    "Choose English or Arabic.": "اختر الإنجليزية أو العربية.",
    "Choose a checklist to work through. Answers are only accepted while the audit is in execution — between the opening and closing meetings.": "اختر قائمة تحقق للعمل عليها. لا تُقبل الإجابات إلا أثناء تنفيذ التدقيق — بين الاجتماعين الافتتاحي والختامي.",
    "Choose a checklist…": "اختر قائمة تحقق…",
    "Choose a colleague": "اختر زميلًا",
    "Choose a new password": "اختر كلمة مرور جديدة",
    "Choose a password different from your current one.": "اختر كلمة مرور مختلفة عن الحالية.",
    "Choose a person": "اختر شخصًا",
    "Choose a project": "اختر مشروعًا",
    "Choose a project…": "اختر مشروعًا…",
    "Choose a report": "اختر تقريرًا",
    "Choose a risk level": "اختر مستوى المخاطر",
    "Choose a role": "اختر دورًا",
    "Choose a workbook": "اختر مصنف Excel",
    "Choose an account": "اختر حسابًا",
    "Choose csv or xlsx.": "اختر csv أو xlsx.",
    "Choose csv, xlsx or pdf.": "اختر csv أو xlsx أو pdf.",
    "Choose the filters above to run this report.": "اختر عوامل التصفية أعلاه لتشغيل هذا التقرير.",
    "Choose which report the list sends before switching it on.": "اختر التقرير الذي ترسله القائمة قبل تفعيلها.",
    "Choose which report the list sends first.": "اختر التقرير الذي ترسله القائمة أولًا.",
    "Choose which version to keep.": "اختر النسخة التي تُحتفظ بها.",
    "Choose…": "اختر…",
    "Classification": "التصنيف",
    "Classify findings as conformity, observation, minor or major NC.": "صنّف الملاحظات كمطابقة أو ملاحظة أو عدم مطابقة بسيطة أو جسيمة.",
    "Clause": "البند",
    "Clause (optional)": "البند (اختياري)",
    "Clear": "مسح",
    "Clear all": "مسح الكل",
    "Clocks": "المؤقتات",
    "Close the audit": "إغلاق التدقيق",
    "Close this audit": "إغلاق هذا التدقيق",
    "Closed": "مغلق",
    "Closed — NOT effective": "مغلق — غير فعّال",
    "Closed — effective": "مغلق — فعّال",
    "Closing": "ختامي",
    "Closing meeting": "الاجتماع الختامي",
    "Closing minutes": "محضر الاجتماع الختامي",
    "Closure rate": "نسبة الإغلاق",
    "Closure rate %": "نسبة الإغلاق ٪",
    "Code": "الرمز",
    "Colour": "اللون",
    "Columns: username, roleKey, businessUnitCodes, projectCodes, expiresAt. roleKey is a shipped role's key or a custom role's name. The two code columns are semicolon-separated. expiresAt is a date — access ends as that day ends, organisation time.": "الأعمدة: username وroleKey وbusinessUnitCodes وprojectCodes وexpiresAt. قيمة roleKey هي مفتاح دور مرفق أو اسم دور مخصص. عمودا الرموز مفصولان بفاصلة منقوطة. expiresAt تاريخ — تنتهي الصلاحية بانتهاء ذلك اليوم بتوقيت المنظمة.",
    "Communication": "التواصل",
    "Composed": "أُعدّ",
    "Composed from the data captured against": "أُعدّ من البيانات المسجلة مقابل",
    "Composing the report…": "جارٍ إعداد التقرير…",
    "Configuration decides how the whole organisation is measured and chased, so it needs configuration authority rather than ordinary access.": "الإعدادات تحدد كيف تُقاس المنظمة كلها وتُتابَع، لذا تحتاج إلى صلاحية الإعداد لا إلى صلاحية الوصول العادية.",
    "Configure Masters": "إعداد البيانات الرئيسية",
    "Confirm new password": "تأكيد كلمة المرور الجديدة",
    "Confirm send back": "تأكيد الإعادة",
    "Conflict": "التعارض",
    "Conformity": "مطابقة",
    "Conforms": "مطابق",
    "Connected": "متصل",
    "Connection health check": "فحص سلامة الاتصال",
    "Connections": "الاتصالات",
    "Connections to other systems are shared by all three applications, so changing them needs integration authority in all three.": "الاتصالات بالأنظمة الأخرى مشتركة بين التطبيقات الثلاثة، لذا يحتاج تغييرها إلى صلاحية التكامل في الثلاثة.",
    "Connections to other systems — the mail server first — with their health, a sandbox mode, and the email outbox.": "الاتصالات بالأنظمة الأخرى — خادم البريد أولًا — مع حالتها، ووضع البيئة التجريبية، وصندوق البريد الصادر.",
    "Connections to other systems. Shared by all three applications.": "الاتصالات بالأنظمة الأخرى. مشتركة بين التطبيقات الثلاثة.",
    "Contact for the push services (mailto: or https: link)": "جهة الاتصال لخدمات الإشعارات الفورية (رابط mailto: أو https:)",
    "Container authentication is not the active strategy. Set AUTH_STRATEGY=container.": "المصادقة عبر الحاوية ليست الاستراتيجية النشطة. اضبط AUTH_STRATEGY=container.",
    "Copied": "تم النسخ",
    "Copy": "نسخ",
    "Correction": "التصحيح",
    "Correction taken": "التصحيح المتخذ",
    "Correction — what was done about this instance": "التصحيح — ما الذي تم بشأن هذه الحالة",
    "Corrective Action Reports": "تقارير الإجراءات التصحيحية",
    "Corrective action": "الإجراء التصحيحي",
    "Corrective action — what stops it happening again": "الإجراء التصحيحي — ما الذي يمنع تكراره",
    "Corrective action:": "الإجراء التصحيحي:",
    "Corrective actions": "الإجراءات التصحيحية",
    "Corrective actions — one per responsible department, tracked independently.": "الإجراءات التصحيحية — واحد لكل إدارة مسؤولة، ويُتابَع كل منها على حدة.",
    "Corrective actions: status and closure": "الإجراءات التصحيحية: الحالة والإغلاق",
    "Correspondence in": "المراسلات الواردة",
    "Correspondence out": "المراسلات الصادرة",
    "Could not load the dashboard.": "تعذّر تحميل لوحة المتابعة.",
    "Could not load this application.": "تعذّر تحميل هذا التطبيق.",
    "Could not open that period.": "تعذّر فتح تلك الفترة.",
    "Could not request a draft.": "تعذّر طلب مسودة.",
    "Could not save the brief.": "تعذّر حفظ الموجز.",
    "Count": "العدد",
    "Counts and closure rates below are for": "الأعداد ونسب الإغلاق أدناه تخص",
    "Counts are entered. Closure rate and variance are calculated and cannot be edited.": "الأعداد تُدخَل. نسبة الإغلاق والتغيّر محسوبتان ولا يمكن تعديلهما.",
    "Create": "إنشاء",
    "Create / Edit": "إنشاء / تعديل",
    "Create account": "إنشاء حساب",
    "Create an account": "إنشاء حساب",
    "Create plan": "إنشاء خطة",
    "Create role": "إنشاء دور",
    "Creating…": "جارٍ الإنشاء…",
    "Criteria": "المعايير",
    "Criteria — what it is being judged against": "المعايير — ما الذي يُقيَّم على أساسه",
    "Currency": "العملة",
    "Current password": "كلمة المرور الحالية",
    "Customer Satisfaction": "رضا العملاء",
    "Customer satisfaction": "رضا العملاء",
    "Customer satisfaction: summary and trend": "رضا العملاء: الملخص والاتجاه",
    "Customised": "مخصص",
    "Daily": "يومي",
    "Daily Document Governance Log": "سجل حوكمة الوثائق اليومي",
    "Daily document governance log missing": "سجل حوكمة الوثائق اليومي غير مُدخل",
    "Daily entries": "السجلات اليومية",
    "Daily submittals and drawings, their status and review time.": "التقديمات والمخططات اليومية وحالتها ومدة مراجعتها.",
    "Damage": "تالف",
    "Dashboard": "لوحة المتابعة",
    "Data Sync Cockpit": "مركز مزامنة البيانات",
    "Data leaves Algihaz’s systems.": "تغادر البيانات أنظمة Algihaz.",
    "Date": "التاريخ",
    "Dates:": "التواريخ:",
    "Days logged": "الأيام المسجلة",
    "Days open": "أيام الفتح",
    "Days overdue": "أيام التأخير",
    "Deadline missed": "فات الموعد النهائي",
    "Default wording": "الصياغة الافتراضية",
    "Delegate": "تفويض",
    "Delegate my roles": "فوّض أدواري",
    "Delegation": "التفويض",
    "Delegation register": "سجل التفويضات",
    "Denied": "رُفض",
    "Department": "الإدارة",
    "Departments. A corrective action is owned by one of these, so retiring one leaves the work it owns intact and simply stops it being chosen again.": "الإدارات. يمتلك الإجراءَ التصحيحي إحداها، لذا فإن إيقاف إحداها يُبقي العمل الذي تملكه كما هو ويمنع اختيارها مجددًا فقط.",
    "Describe it in a sentence": "صِفه في جملة",
    "Describe the day in a sentence": "صِف اليوم في جملة",
    "Describe the day in a sentence or two.": "صِف اليوم في جملة أو جملتين.",
    "Describe the day's document activity": "صِف نشاط الوثائق لهذا اليوم",
    "Describe the finding": "صِف الملاحظة",
    "Describe the finding in a sentence": "صِف الملاحظة في جملة",
    "Describe the finding in a sentence or two.": "صِف الملاحظة في جملة أو جملتين.",
    "Describe the lesson": "صِف الدرس",
    "Describe the lesson in a sentence or two.": "صِف الدرس في جملة أو جملتين.",
    "Description": "الوصف",
    "Description of the issue": "وصف المشكلة",
    "Details": "التفاصيل",
    "Development and UAT sign-in. In production each application receives its identity from the Algihaz platform container.": "تسجيل دخول للتطوير واختبار القبول. في بيئة الإنتاج يتلقى كل تطبيق هوية المستخدم من حاوية منصة Algihaz.",
    "Direction": "الاتجاه",
    "Disabled — nothing matching this rule starts a clock, so nobody is chased.": "معطّل — لا شيء يطابق هذه القاعدة يبدأ مؤقتًا، لذا لا تُجرى متابعة لأحد.",
    "Discard": "تجاهل",
    "Discard AI draft": "تجاهل مسودة الذكاء الاصطناعي",
    "Discipline": "التخصص",
    "Disciplines": "التخصصات",
    "Distribution Lists": "قوائم التوزيع",
    "Distribution Lists & Templates": "قوائم التوزيع والقوالب",
    "Distribution list": "قائمة التوزيع",
    "Distribution lists need configuration authority in": "قوائم التوزيع تحتاج إلى صلاحية الإعداد في",
    "Document": "مستند",
    "Document Controller": "مراقب الوثائق",
    "Document Governance Log": "سجل حوكمة الوثائق",
    "Document Governance roll-up": "تجميع حوكمة الوثائق",
    "Documentation": "التوثيق",
    "Documents": "الوثائق",
    "Does not conform": "غير مطابق",
    "Done": "تم",
    "Download as PDF": "تنزيل بصيغة PDF",
    "Download the approval memo (PDF)": "تنزيل مذكرة الاعتماد (PDF)",
    "Download the issued report (PDF)": "تنزيل التقرير الصادر (PDF)",
    "Draft": "مسودة",
    "Draft moved into the editor. Change it, then save.": "نُقلت المسودة إلى المحرر. عدّلها ثم احفظ.",
    "Draft the Quality Assessment Brief": "صياغة موجز تقييم الجودة",
    "Draft with AI": "صياغة بالذكاء الاصطناعي",
    "Draw on it": "ارسم عليها",
    "Draw on the photo": "ارسم على الصورة",
    "Drawings": "المخططات",
    "Dry run": "تشغيل تجريبي",
    "Due": "مستحق",
    "Duration (minutes)": "المدة (بالدقائق)",
    "Each band must be longer than the one before.": "يجب أن تكون كل فئة أطول من التي قبلها.",
    "Each one on or off. A feature switched off is off for everyone, whatever the screen shows.": "كلٌّ منها مفعّل أو معطّل. الميزة المعطّلة معطّلة للجميع، مهما أظهرت الشاشة.",
    "Each person switches push on for each of their devices, from Notifications. Messages are encrypted for the device; the browser’s push service carries them but cannot read them.": "يفعّل كل شخص الإشعارات الفورية لكل جهاز من أجهزته من صفحة الإشعارات. الرسائل مشفرة للجهاز؛ تنقلها خدمة الإشعارات في المتصفح لكنها لا تستطيع قراءتها.",
    "Each project’s daily log over a date range: submittals, drawings, review outcomes and correspondence.": "السجل اليومي لكل مشروع خلال نطاق تاريخي: التقديمات والمخططات ونتائج المراجعة والمراسلات.",
    "Each report shows only the records your role lets you see. Opening or exporting one is recorded.": "يعرض كل تقرير السجلات التي يسمح لك دورك برؤيتها فقط. فتح أي منها أو تصديره يُسجَّل.",
    "Each run covers the period that has just closed: yesterday, the half-month, last month or last quarter.": "يغطي كل تشغيل الفترة التي انتهت للتو: أمس، أو نصف الشهر، أو الشهر الماضي، أو الربع الماضي.",
    "Earlier versions (": "الإصدارات السابقة (",
    "Edit": "تعديل",
    "Edit list": "تعديل القائمة",
    "Edit permissions": "تعديل الصلاحيات",
    "Edit plan": "تعديل الخطة",
    "Edit the finding": "تعديل الملاحظة",
    "Edit the marks": "تعديل العلامات",
    "Edit year or title": "تعديل السنة أو العنوان",
    "Edit {0}": "تعديل {0}",
    "Effective — close it": "فعّال — أغلقه",
    "Email": "البريد الإلكتروني",
    "Email delivery": "تسليم البريد الإلكتروني",
    "Email is composed and kept here, marked not sent. It is not sent later by itself: once email is set up, send a message again from this list if it still matters.": "يُعَدّ البريد الإلكتروني ويُحفظ هنا مع وسمه بأنه غير مرسل. لا يُرسل لاحقًا من تلقاء نفسه: بعد إعداد البريد، أعد إرسال الرسالة من هذه القائمة إن كانت لا تزال مهمة.",
    "Email or password is incorrect.": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
    "Email outbox": "صندوق البريد الصادر",
    "Email switched on": "تم تفعيل البريد الإلكتروني",
    "Employee (base)": "موظف (أساسي)",
    "Empty": "فارغ",
    "Enabled": "مفعّل",
    "End it now": "أنهِه الآن",
    "End this delegation now?": "إنهاء هذا التفويض الآن؟",
    "Ended": "انتهى",
    "Ends (optional — the end of that day, organisation time)": "ينتهي (اختياري — بنهاية ذلك اليوم بتوقيت المنظمة)",
    "English": "English",
    "Enter the secret.": "أدخل القيمة السرية.",
    "Entered and approved daily. Distribution is fortnightly — the summary at the bottom is that view, not a second approval.": "يُدخَل ويُعتمد يوميًا. التوزيع كل أسبوعين — الملخص في الأسفل هو ذلك العرض، وليس اعتمادًا ثانيًا.",
    "Entries": "السجلات",
    "Entry is closed while the report is": "الإدخال مغلق بينما التقرير",
    "Error": "خطأ",
    "Escalated": "مُصعَّد",
    "Escalated to the next level": "صُعِّد إلى المستوى التالي",
    "Escalation Matrix Configuration": "إعداد مصفوفة التصعيد",
    "Escalation Summary": "ملخص التصعيد",
    "Escalation matrix": "مصفوفة التصعيد",
    "Escalation summary": "ملخص التصعيد",
    "Escalation sweep": "مسح التصعيد",
    "Every SLA clock in QMS360 counts working days against this. Changing it changes when everything is due.": "كل مؤقت لاتفاقية مستوى الخدمة في QMS360 يحسب أيام العمل على أساس هذا. تغييره يغيّر مواعيد استحقاق كل شيء.",
    "Every SLA clock: what it is waiting on, how far it has escalated, and whether it breached.": "كل مؤقت لاتفاقية مستوى الخدمة: ما الذي ينتظره، وإلى أي حد صُعّد، وهل تم تجاوزه.",
    "Every audit, where it stands, and who leads it.": "كل تدقيق، وأين وصل، ومن يقوده.",
    "Every corrective action issued in the range, where it stands, and whether it was verified effective.": "كل إجراء تصحيحي صدر في النطاق، وأين وصل، وهل ثبتت فعاليته.",
    "Every device switched on now will be switched off, and people must turn push on again.": "كل جهاز مفعّل الآن سيُعطَّل، وعلى الأشخاص تفعيل الإشعارات الفورية مرة أخرى.",
    "Every finding raised in the range, by classification.": "كل ملاحظة سُجّلت في النطاق، حسب التصنيف.",
    "Every lesson captured in the range, with its category, impact and status.": "كل درس التُقط في النطاق، مع فئته وأثره وحالته.",
    "Every message goes here in sandbox mode": "كل رسالة تذهب إلى هنا في وضع البيئة التجريبية",
    "Every monthly report in the period, with its status and Project Quality Index.": "كل تقرير شهري في الفترة، مع حالته ومؤشر جودة المشروع.",
    "Every project the list's person can see": "كل مشروع يستطيع صاحب القائمة رؤيته",
    "Every recorded action, filterable and exportable. Nothing in it can be changed or deleted, by anyone.": "كل إجراء مسجَّل، قابل للتصفية والتصدير. لا يمكن لأحد تغيير أي شيء فيه أو حذفه.",
    "Every recorded action. Nothing here can be changed or deleted, by anyone. Searching and exporting are recorded too.": "كل إجراء مسجَّل. لا يمكن لأحد تغيير أي شيء هنا أو حذفه. البحث والتصدير يُسجَّلان أيضًا.",
    "Every report for this application, on screen and as Excel, CSV or PDF.": "كل تقارير هذا التطبيق، على الشاشة وبصيغ Excel وCSV وPDF.",
    "Every run of everything that runs by itself. Delivery appears only when there was something to send.": "كل تشغيل لكل ما يعمل تلقائيًا. يظهر التسليم فقط عندما يوجد ما يُرسل.",
    "Every suggestion: what was asked, what came back, and what the person did with it. Opening this list is recorded.": "كل اقتراح: ما الذي طُلب، وما الذي عاد، وما الذي فعله الشخص به. فتح هذه القائمة يُسجَّل.",
    "Everybody holding this role gets the change on their next request.": "كل من يحمل هذا الدور يحصل على التغيير في طلبه التالي.",
    "Everything": "كل شيء",
    "Evidence": "الأدلة",
    "Evidence summary (optional)": "ملخص الأدلة (اختياري)",
    "Evidence:": "الأدلة:",
    "Excel": "Excel",
    "Executive 360": "الرؤية التنفيذية 360",
    "Executive Viewer": "مشاهد تنفيذي",
    "Export": "تصدير",
    "Export CSV": "تصدير CSV",
    "Export Excel": "تصدير Excel",
    "Export PDF": "تصدير PDF",
    "Export this month, fill in the figures, and upload the workbook here. You will see every change before anything is saved.": "صدّر هذا الشهر، واملأ الأرقام، وارفع المصنف هنا. سترى كل تغيير قبل حفظ أي شيء.",
    "Export to Excel": "تصدير إلى Excel",
    "Export {0}": "تصدير {0}",
    "Exporting needs the export permission.": "التصدير يحتاج إلى صلاحية التصدير.",
    "Exporting…": "جارٍ التصدير…",
    "Extended to": "مُدّد إلى",
    "Extension point": "نقطة توسعة",
    "External / Guest Auditor": "مدقق خارجي / زائر",
    "External NCR": "عدم مطابقة خارجية (NCR)",
    "Failed": "فشل",
    "Failing": "متعثر",
    "Feasibility notes": "ملاحظات الجدوى",
    "Feature toggles, model selection, data guardrails and quota. Human-in-the-loop is enforced at the API and cannot be switched off.": "مفاتيح تشغيل الميزات، واختيار النموذج، وضوابط البيانات، والحصة. تُفرض مراجعة الإنسان على مستوى الواجهة البرمجية ولا يمكن إيقافها.",
    "Features": "الميزات",
    "Feed": "المصدر",
    "Feed address": "عنوان المصدر",
    "Feedback (optional)": "الملاحظات (اختياري)",
    "Feeds App 2's dropdowns and the risk half of App 3's priority matrix — a risk level here is what a finding's classification is crossed with to reach P1–P6.": "تغذّي القوائم المنسدلة في التطبيق الثاني ونصف المخاطر في مصفوفة الأولوية في التطبيق الثالث — مستوى المخاطر هنا هو ما يُقاطَع مع تصنيف الملاحظة للوصول إلى P1–P6.",
    "Feeds the dropdowns in App 1 and App 2 — nobody types a discipline by hand.": "تغذّي القوائم المنسدلة في التطبيقين الأول والثاني — لا أحد يكتب التخصص يدويًا.",
    "Field mapping": "تعيين الحقول",
    "Figure": "الرقم",
    "File": "الملف",
    "Fill in a Document Governance Log entry from a sentence": "تعبئة سجل حوكمة الوثائق من جملة",
    "Fill in a new lesson from a sentence": "تعبئة درس جديد من جملة",
    "Fill in the form": "املأ النموذج",
    "Filling the form in from a sentence needs a signal. The form below works as usual.": "تعبئة النموذج من جملة تحتاج إلى إشارة. النموذج أدناه يعمل كالمعتاد.",
    "Filterable by project group, project, month and category.": "قابل للتصفية حسب مجموعة المشاريع والمشروع والشهر والفئة.",
    "Filters": "عوامل التصفية",
    "Finding": "الملاحظة",
    "Findings": "الملاحظات",
    "Findings & NCs": "الملاحظات وحالات عدم المطابقة",
    "Findings and corrective actions are counted separately on purpose: one finding can spawn one corrective action per responsible department, so the two numbers answer different questions.": "تُحسب الملاحظات والإجراءات التصحيحية كلٌّ على حدة عمدًا: قد تنتج الملاحظة الواحدة إجراءً تصحيحيًا لكل إدارة مسؤولة، لذا يجيب الرقمان عن سؤالين مختلفين.",
    "Findings by classification": "الملاحظات حسب التصنيف",
    "Findings log": "سجل الملاحظات",
    "First": "الأول",
    "First-run setup": "الإعداد الأولي",
    "Follow-up audit": "تدقيق المتابعة",
    "Follow-up of": "متابعة لـ",
    "Follow-up scheduled": "تمت جدولة المتابعة",
    "For accounts that sign in with a QMS360 password (development and UAT). Takes effect the next time anyone chooses a password; existing passwords are not affected.": "للحسابات التي تسجّل الدخول بكلمة مرور QMS360 (التطوير واختبار القبول). يسري في المرة التالية التي يختار فيها أي شخص كلمة مرور؛ لا تتأثر كلمات المرور الحالية.",
    "For someone who signs in to QMS360 directly — usually an external Guest Auditor. A Guest Auditor then needs inviting to an audit, from that audit.": "لمن يسجّل الدخول إلى QMS360 مباشرة — عادةً مدقق خارجي زائر. يحتاج المدقق الزائر بعد ذلك إلى دعوة إلى تدقيق، من ذلك التدقيق.",
    "For this application only. The other two applications have their own.": "لهذا التطبيق فقط. للتطبيقين الآخرين إعداداتهما الخاصة.",
    "Form Approver": "معتمِد النماذج",
    "Form Creator": "منشئ النماذج",
    "Format": "الصيغة",
    "Fortnightly (1st and 16th)": "كل أسبوعين (يوم 1 ويوم 16)",
    "Fortnightly summary": "الملخص نصف الشهري",
    "Fri": "الجمعة",
    "From": "من",
    "From the workbook": "من المصنف",
    "Full": "كامل",
    "Generate": "إنشاء",
    "Generate signing keys": "إنشاء مفاتيح التوقيع",
    "Generate the signing keys before switching push on.": "أنشئ مفاتيح التوقيع قبل تفعيل الإشعارات الفورية.",
    "Generated": "أُنشئ",
    "Generated by QMS360 on {0} for {1}.": "أنشأه QMS360 في {0} لـ {1}.",
    "Generated by QMS360 on {0}.": "أنشأه QMS360 في {0}.",
    "Give the Arabic subject and body together, or leave both empty.": "أدخل الموضوع والنص بالعربية معًا، أو اتركهما فارغين.",
    "Given and received": "الممنوحة والمستلمة",
    "Grant": "منح",
    "Grant a role": "منح دور",
    "Guest Auditor": "مدقق زائر",
    "Guest Auditors": "المدققون الزائرون",
    "Guest invitation": "دعوة زائر",
    "Guidance for the auditor (optional)": "إرشاد للمدقق (اختياري)",
    "Guided, dropdown-first capture with photo evidence. Works offline.": "إدخال موجَّه يعتمد على القوائم المنسدلة مع أدلة مصورة. يعمل دون اتصال.",
    "Hand your roles to a colleague while you are away, and see what you hold for others.": "سلّم أدوارك لزميل أثناء غيابك، واطّلع على ما تحمله نيابة عن الآخرين.",
    "Handle with care": "يُتعامل معه بحذر",
    "Hazardous": "خطِر",
    "Held at": "عُقد في",
    "Hide": "إخفاء",
    "Higher is better (≥)": "الأعلى أفضل (≥)",
    "Holiday": "عطلة",
    "Home": "الرئيسية",
    "How": "كيف",
    "How App 1's composite index is calculated. Saving creates a NEW VERSION rather than editing this one, so a report approved last month still means what it meant.": "كيف يُحسب المؤشر المركّب للتطبيق الأول. الحفظ ينشئ إصدارًا جديدًا بدلًا من تعديل هذا، لذا يبقى التقرير المعتمد الشهر الماضي بالمعنى نفسه.",
    "How long entries stay in the live log before they may be archived. Entries are never deleted, by anyone — archiving moves old entries elsewhere and is done by operations, not by QMS360.": "مدة بقاء السجلات في السجل الحي قبل جواز أرشفتها. لا يحذف أحد أي سجل — الأرشفة تنقل السجلات القديمة إلى مكان آخر وتتولاها فرق التشغيل، لا QMS360.",
    "How many times": "كم مرة",
    "How often": "كم مرة",
    "How you are told": "كيف يتم إبلاغك",
    "Impact": "الأثر",
    "Import from Excel": "استيراد من Excel",
    "Imported —": "تم الاستيراد —",
    "In": "في",
    "In progress": "قيد التنفيذ",
    "In the app": "داخل التطبيق",
    "Index": "المؤشر",
    "Input price per million tokens": "سعر الإدخال لكل مليون رمز",
    "Integration Cockpit": "مركز التكامل",
    "Integration and job health": "سلامة التكاملات والمهام",
    "Internal NCR": "عدم مطابقة داخلية (NCR)",
    "Internal audit programme": "برنامج التدقيق الداخلي",
    "Invalid token.": "رمز غير صالح.",
    "Invite": "دعوة",
    "Invite a Guest Auditor": "دعوة مدقق زائر",
    "Issue": "إصدار",
    "Issue again from this preview": "أعد الإصدار من هذه المعاينة",
    "Issue category": "فئة المشكلة",
    "Issue follow-up": "إصدار متابعة",
    "Issue the report (PDF)": "إصدار التقرير (PDF)",
    "Issued": "صدر",
    "Issued report": "التقرير الصادر",
    "Issuing keeps this report as a PDF, the document of record. Sending it to a distribution list is not available yet, so nothing here says it was sent.": "الإصدار يحفظ هذا التقرير بصيغة PDF بوصفه الوثيقة المرجعية. إرساله إلى قائمة توزيع غير متاح بعد، لذا لا يوجد هنا ما يفيد بأنه أُرسل.",
    "Issuing…": "جارٍ الإصدار…",
    "It has not run yet.": "لم يعمل بعد.",
    "Item": "البند",
    "Items": "البنود",
    "Items waiting on your approval.": "العناصر التي تنتظر اعتمادك.",
    "Job": "المهمة",
    "Job monitor": "مراقب المهام",
    "Keep it": "أبقِه",
    "Keep online for (months)": "الإبقاء متاحًا لمدة (أشهر)",
    "Keep this one": "أبقِ هذا",
    "Kept (edited)": "مُبقى (معدّل)",
    "Key ending {0}, saved {1}.": "مفتاح ينتهي بـ {0}، حُفظ في {1}.",
    "Key storage is not set up on this server, so keys can only come from the server’s own configuration.": "تخزين المفاتيح غير مُعدّ على هذا الخادم، لذا لا تأتي المفاتيح إلا من إعدادات الخادم نفسه.",
    "Language": "اللغة",
    "Last run": "آخر تشغيل",
    "Latest": "الأحدث",
    "Lead auditor": "المدقق الرئيسي",
    "Lead auditor and team": "المدقق الرئيسي والفريق",
    "Lead:": "الرئيسي:",
    "Lesson": "الدرس",
    "Lesson Learned": "الدروس المستفادة",
    "Lesson Learned Log": "سجل الدروس المستفادة",
    "Lesson Learned Management": "إدارة الدروس المستفادة",
    "Lesson Learned records": "سجلات الدروس المستفادة",
    "Lesson learned: {0}": "درس مستفاد: {0}",
    "Lessons": "الدروس",
    "Lessons awaiting approval": "دروس بانتظار الاعتماد",
    "Letters in": "الخطابات الواردة",
    "Letters out": "الخطابات الصادرة",
    "Level": "المستوى",
    "Lists": "القوائم",
    "Load older": "تحميل الأقدم",
    "Load older entries": "تحميل السجلات الأقدم",
    "Loading projects…": "جارٍ تحميل المشاريع…",
    "Loading…": "جارٍ التحميل…",
    "Local login is disabled. This deployment authenticates through the platform container.": "تسجيل الدخول المحلي معطّل. هذا النشر يصادق عبر حاوية المنصة.",
    "Locating…": "جارٍ تحديد الموقع…",
    "Location": "الموقع",
    "Location is captured by the device. If it cannot get a fix, the reason is recorded rather than left blank.": "يلتقط الجهاز الموقع. إذا تعذّر تحديده، يُسجَّل السبب بدلًا من تركه فارغًا.",
    "Location:": "الموقع:",
    "Log date": "تاريخ السجل",
    "Log entry": "سجل حوكمة الوثائق",
    "Lower is better (≤)": "الأقل أفضل (≤)",
    "MIRN counts, OSD and status distribution, reconciled to the total.": "أعداد MIRN، والزيادة والنقص والتلف (OSD)، وتوزيع الحالات، مطابَقة مع الإجمالي.",
    "MIRN total": "إجمالي MIRN",
    "Mail server": "خادم البريد",
    "Major": "جسيم",
    "Major NC": "عدم مطابقة جسيمة",
    "Major nc": "عدم مطابقة جسيمة",
    "Making a PDF needs a connection.": "إنشاء ملف PDF يحتاج إلى اتصال.",
    "Making the PDF…": "جارٍ إنشاء ملف PDF…",
    "Malformed token.": "رمز بصيغة غير سليمة.",
    "Manage AI Settings": "إدارة إعدادات الذكاء الاصطناعي",
    "Manage Integrations": "إدارة التكاملات",
    "Managing AI needs the Manage AI Settings permission in this application.": "إدارة الذكاء الاصطناعي تحتاج إلى صلاحية إدارة إعدادات الذكاء الاصطناعي في هذا التطبيق.",
    "Mark all read": "تعليم الكل كمقروء",
    "Mark read": "تعليم كمقروء",
    "Master Data": "البيانات الرئيسية",
    "Master data": "البيانات الرئيسية",
    "Master data & configuration": "البيانات الرئيسية والإعدادات",
    "Material Inspection": "فحص المواد",
    "Material inspection": "فحص المواد",
    "Measure": "المقياس",
    "Meeting minutes": "محاضر الاجتماعات",
    "Meetings": "الاجتماعات",
    "Memo distributed:": "وُزّعت المذكرة:",
    "Message": "الرسالة",
    "Metric": "المقياس",
    "Metric category": "فئة المقياس",
    "Metrics": "المقاييس",
    "Minimum password length": "الحد الأدنى لطول كلمة المرور",
    "Minor": "بسيط",
    "Minor NC": "عدم مطابقة بسيطة",
    "Minor nc": "عدم مطابقة بسيطة",
    "Minutes": "المحضر",
    "Missing file id.": "مُعرِّف الملف مفقود.",
    "Missing-submission check": "فحص الإدخالات المفقودة",
    "MoM": "شهري",
    "Model (optional)": "النموذج (اختياري)",
    "Moderate": "متوسط",
    "Mon": "الاثنين",
    "Month": "الشهر",
    "Month over month": "التغيّر الشهري",
    "Monthly": "شهري",
    "Monthly Project Quality Report": "تقرير جودة المشروع الشهري",
    "Monthly QA/QC Report —": "تقرير ضمان الجودة/مراقبة الجودة الشهري —",
    "Monthly QA/QC Reports": "تقارير ضمان الجودة/مراقبة الجودة الشهرية",
    "Monthly QA/QC report missing": "تقرير ضمان الجودة/مراقبة الجودة الشهري غير مُدخل",
    "Monthly narrative": "السرد الشهري",
    "Monthly narrative, with an AI first draft you accept, edit or reject.": "سرد شهري، مع مسودة أولى بالذكاء الاصطناعي تقبلها أو تعدّلها أو ترفضها.",
    "Monthly quota": "الحصة الشهرية",
    "Monthly report": "التقرير الشهري",
    "Monthly reports": "التقارير الشهرية",
    "Monthly reports: status and PQI": "التقارير الشهرية: الحالة ومؤشر الجودة",
    "Movement (points)": "التغيّر (نقاط)",
    "Movement on last month (points)": "التغيّر عن الشهر الماضي (نقاط)",
    "My Delegations": "تفويضاتي",
    "My Lessons": "دروسي",
    "My delegations": "تفويضاتي",
    "NC recurrence and trend": "تكرار حالات عدم المطابقة واتجاهها",
    "NCR, RFI and RMI counts with ageing buckets and auto-calculated closure rates.": "أعداد NCR وRFI وRMI مع فئات التقادم ونسب إغلاق محسوبة تلقائيًا.",
    "Name": "الاسم",
    "Name at least one responsible department.": "حدّد إدارة مسؤولة واحدة على الأقل.",
    "Name the field to rewrite.": "حدّد الحقل المراد إعادة صياغته.",
    "Negative": "سلبي",
    "Never shown again once stored.": "لا يُعرض مرة أخرى بعد حفظه.",
    "New Lesson Learned": "درس مستفاد جديد",
    "New account": "حساب جديد",
    "New checklist": "قائمة تحقق جديدة",
    "New checklist name": "اسم قائمة التحقق الجديدة",
    "New date": "التاريخ الجديد",
    "New delegation": "تفويض جديد",
    "New distribution list": "قائمة توزيع جديدة",
    "New lesson": "درس جديد",
    "New list": "قائمة جديدة",
    "New password": "كلمة المرور الجديدة",
    "New plan": "خطة جديدة",
    "Next run {0}. Last run {1}.": "التشغيل التالي {0}. آخر تشغيل {1}.",
    "No AI suggestions yet.": "لا توجد اقتراحات من الذكاء الاصطناعي بعد.",
    "No SLA clocks in this range.": "لا توجد مؤقتات اتفاقية مستوى خدمة في هذا النطاق.",
    "No action needed": "لا يلزم إجراء",
    "No active session.": "لا توجد جلسة نشطة.",
    "No audit plans yet.": "لا توجد خطط تدقيق بعد.",
    "No audit programme has been started yet.": "لم يبدأ أي برنامج تدقيق بعد.",
    "No audits are planned in this programme.": "لا توجد عمليات تدقيق مخططة في هذا البرنامج.",
    "No audits in this range.": "لا توجد عمليات تدقيق في هذا النطاق.",
    "No audits planned yet.": "لم تُخطَّط عمليات تدقيق بعد.",
    "No audits yet.": "لا توجد عمليات تدقيق بعد.",
    "No audits.": "لا توجد عمليات تدقيق.",
    "No brief recorded for this month.": "لم يُسجَّل موجز لهذا الشهر.",
    "No checklist answers yet.": "لا توجد إجابات لقائمة التحقق بعد.",
    "No connection has been set up.": "لم يُعدّ أي اتصال.",
    "No corrective action is open.": "لا يوجد إجراء تصحيحي مفتوح.",
    "No corrective action.": "لا يوجد إجراء تصحيحي.",
    "No corrective actions issued in this range.": "لم تصدر إجراءات تصحيحية في هذا النطاق.",
    "No corrective actions.": "لا توجد إجراءات تصحيحية.",
    "No customer satisfaction responses for this month.": "لا توجد ردود رضا عملاء لهذا الشهر.",
    "No customer satisfaction responses in this range.": "لا توجد ردود رضا عملاء في هذا النطاق.",
    "No daily logs in this range.": "لا توجد سجلات يومية في هذا النطاق.",
    "No delegations on record.": "لا توجد تفويضات مسجلة.",
    "No description recorded.": "لم يُسجَّل وصف.",
    "No distribution lists for": "لا توجد قوائم توزيع لـ",
    "No draft this time. Fill the form in by hand.": "لا توجد مسودة هذه المرة. املأ النموذج يدويًا.",
    "No email yet.": "لا يوجد بريد بعد.",
    "No entries match these filters.": "لا توجد سجلات تطابق عوامل التصفية هذه.",
    "No evidence recorded.": "لم تُسجَّل أدلة.",
    "No evidence was recorded.": "لم تُسجَّل أدلة.",
    "No findings have been raised in the audits your scope reaches.": "لم تُسجَّل ملاحظات في عمليات التدقيق التي يشملها نطاقك.",
    "No findings in this range.": "لا توجد ملاحظات في هذا النطاق.",
    "No findings match these filters.": "لا توجد ملاحظات تطابق عوامل التصفية هذه.",
    "No findings raised.": "لم تُسجَّل ملاحظات.",
    "No findings were raised.": "لم تُسجَّل ملاحظات.",
    "No findings.": "لا توجد ملاحظات.",
    "No holidays configured.": "لم تُضبط عطل.",
    "No key.": "لا يوجد مفتاح.",
    "No lead auditor recorded. ": "لم يُسجَّل مدقق رئيسي. ",
    "No lessons captured in this range.": "لم تُلتقط دروس في هذا النطاق.",
    "No lessons match. The first one recorded on a project starts its log.": "لا توجد دروس مطابقة. أول درس يُسجَّل على مشروع يبدأ سجله.",
    "No lessons.": "لا توجد دروس.",
    "No limit": "بلا حد",
    "No log entries yet for the projects you can see.": "لا توجد سجلات بعد للمشاريع التي يمكنك رؤيتها.",
    "No longer in the feed, kept active until someone decides:": "لم يعد موجودًا في المصدر، ويبقى نشطًا حتى يقرر أحد:",
    "No marks yet.": "لا توجد علامات بعد.",
    "No material inspection recorded for this month.": "لم يُسجَّل فحص مواد لهذا الشهر.",
    "No metrics recorded for this month.": "لم تُسجَّل مقاييس لهذا الشهر.",
    "No modules available yet": "لا توجد وحدات متاحة بعد",
    "No monthly reports in this period.": "لا توجد تقارير شهرية في هذه الفترة.",
    "No nonconformities raised.": "لم تُسجَّل حالات عدم مطابقة.",
    "No open clocks.": "لا توجد مؤقتات مفتوحة.",
    "No period set": "لم تُحدَّد فترة",
    "No photos were attached.": "لم تُرفق صور.",
    "No photos yet.": "لا توجد صور بعد.",
    "No plan": "بلا خطة",
    "No price — its calls are counted but not costed.": "بلا سعر — تُحتسب استدعاءاته دون تكلفة.",
    "No prior period to compare": "لا توجد فترة سابقة للمقارنة",
    "No projects you can use": "لا توجد مشاريع يمكنك استخدامها",
    "No questions yet.": "لا توجد أسئلة بعد.",
    "No report chosen": "لم يُختر تقرير",
    "No reporting periods match these filters.": "لا توجد فترات تقارير تطابق عوامل التصفية هذه.",
    "No reporting periods yet for the projects you can see.": "لا توجد فترات تقارير بعد للمشاريع التي يمكنك رؤيتها.",
    "No reports are available to your role in this application.": "لا توجد تقارير متاحة لدورك في هذا التطبيق.",
    "No reports.": "لا توجد تقارير.",
    "No rewrite is available right now.": "لا تتوفر إعادة صياغة الآن.",
    "No targets configured.": "لم تُضبط مستهدفات.",
    "No team recorded.": "لم يُسجَّل فريق.",
    "No toolbox talks recorded for this month.": "لم تُسجَّل اجتماعات توعوية لهذا الشهر.",
    "No workspace role — this person reaches an app home screen and sees no modules.": "بلا دور في مساحة العمل — يصل هذا الشخص إلى الصفحة الرئيسية للتطبيق ولا يرى أي وحدات.",
    "Nobody is invited.": "لم يُدعَ أحد.",
    "Non-conforming": "غير مطابق",
    "Nonconformities and observations": "حالات عدم المطابقة والملاحظات",
    "Nonconformities raised more than once against the same clause in the same department, within the recurrence window.": "حالات عدم المطابقة المسجلة أكثر من مرة مقابل البند نفسه في الإدارة نفسها، خلال نافذة التكرار.",
    "Nonconformities raised per month": "حالات عدم المطابقة المسجلة شهريًا",
    "None": "لا شيء",
    "None of this finding’s corrective actions is for your department.": "لا يوجد بين الإجراءات التصحيحية لهذه الملاحظة إجراء لإدارتك.",
    "None — unencrypted, for a relay inside your network only": "بلا تشفير — لمرحّل داخل شبكتك فقط",
    "None.": "لا شيء.",
    "Not answered": "لم تتم الإجابة",
    "Not applicable": "لا ينطبق",
    "Not approved: this lesson is {0}.": "غير معتمد: هذا الدرس {0}.",
    "Not available to your role": "غير متاح لدورك",
    "Not available yet": "غير متاح بعد",
    "Not checked yet": "لم يُفحص بعد",
    "Not chosen": "لم يُختر",
    "Not connected": "غير متصل",
    "Not effective": "غير فعّال",
    "Not imported from a workbook": "لا يُستورد من المصنف",
    "Not issued yet. What you see is a preview.": "لم يصدر بعد. ما تراه معاينة.",
    "Not part of a programme": "ليس ضمن برنامج",
    "Not recorded": "غير مسجل",
    "Not recorded.": "غير مسجل.",
    "Not sent": "غير مرسل",
    "Not shared": "غير مُشارَك",
    "Not specified": "غير محدد",
    "Not stated, so left for you to enter:": "غير مذكور، لذا تُرك لتدخله:",
    "Note": "ملاحظة",
    "Note for this version (optional)": "ملاحظة لهذا الإصدار (اختياري)",
    "Nothing applied yet.": "لم يُطبَّق شيء بعد.",
    "Nothing configured.": "لم يُضبط شيء.",
    "Nothing has run yet.": "لم يعمل شيء بعد.",
    "Nothing is outstanding. The audit team closes it.": "لا يوجد ما هو معلّق. يغلقه فريق التدقيق.",
    "Nothing is waiting on you.": "لا يوجد ما ينتظرك.",
    "Nothing raised yet.": "لم يُسجَّل شيء بعد.",
    "Nothing recorded yet.": "لم يُسجَّل شيء بعد.",
    "Nothing ticked: the whole application.": "لم يُحدَّد شيء: التطبيق كله.",
    "Nothing to configure": "لا شيء للإعداد",
    "Nothing to reconcile. Everything that synced merged cleanly.": "لا شيء للتسوية. كل ما تمت مزامنته دُمج دون تعارض.",
    "Nothing to show.": "لا شيء للعرض.",
    "Nothing unread.": "لا يوجد غير مقروء.",
    "Nothing was applied — one bad row stops the whole file.": "لم يُطبَّق شيء — صف واحد خاطئ يوقف الملف كله.",
    "Nothing was imported. Fix these in the workbook and upload it again:": "لم يُستورد شيء. صحّح هذه في المصنف وارفعه مرة أخرى:",
    "Nothing yet. Reminders and escalations for your work will appear here.": "لا شيء بعد. ستظهر هنا التذكيرات والتصعيدات المتعلقة بعملك.",
    "Notification wording": "صياغة الإشعارات",
    "Notifications": "الإشعارات",
    "Notifications are blocked for this site in your browser’s settings. Allow them there, then come back.": "الإشعارات محظورة لهذا الموقع في إعدادات متصفحك. اسمح بها هناك ثم عد.",
    "Now": "الآن",
    "Observation": "ملاحظة",
    "Off": "معطّل",
    "Off — every form is filled in by hand": "معطّل — تُملأ كل النماذج يدويًا",
    "Often the right answer when both accounts are partly right.": "غالبًا ما يكون الخيار الصحيح عندما تكون الروايتان صحيحتين جزئيًا.",
    "Older": "أقدم",
    "On": "مفعّل",
    "On for this device.": "مفعّل لهذا الجهاز.",
    "On hold": "معلّق",
    "On the server now": "على الخادم الآن",
    "One corrective action per responsible department, each with its own owner, deadline and closure — so a non-conformity spanning two departments is tracked as two.": "إجراء تصحيحي واحد لكل إدارة مسؤولة، لكلٍّ مالكه وموعده النهائي وإغلاقه — لذا تُتابَع حالة عدم المطابقة التي تمتد عبر إدارتين على أنها اثنتان.",
    "One programme per year. It needs at least one planned audit before it can be submitted — a programme committing to nothing reads like a commitment.": "برنامج واحد لكل سنة. يحتاج إلى تدقيق مخطط واحد على الأقل قبل تقديمه — البرنامج الذي لا يلتزم بشيء يبدو كأنه التزام.",
    "One project’s monthly report: the index, the metrics, inspections, toolbox talks, satisfaction and the brief.": "التقرير الشهري لمشروع واحد: المؤشر والمقاييس والفحوصات والاجتماعات التوعوية والرضا والموجز.",
    "Only a Guest Auditor account can be invited. An access administrator creates one in Users & roles.": "لا يمكن دعوة إلا حساب مدقق زائر. ينشئه مسؤول الصلاحيات في المستخدمون والأدوار.",
    "Only a message that was not sent, or that failed, can be sent again.": "لا يمكن إعادة الإرسال إلا لرسالة لم تُرسل أو فشلت.",
    "Only a non-conformity carries a risk level.": "مستوى المخاطر يخص حالة عدم المطابقة فقط.",
    "Only a non-conformity has one": "لا يخص إلا حالة عدم المطابقة",
    "Only an approved programme has a memo.": "لا توجد مذكرة إلا للبرنامج المعتمد.",
    "Only anthropic and gemini take an API key.": "لا يأخذ مفتاح واجهة برمجية إلا anthropic وgemini.",
    "Only the audits your scope reaches are counted.": "تُحتسب عمليات التدقيق التي يشملها نطاقك فقط.",
    "Only the audits your scope reaches are listed.": "تُعرض عمليات التدقيق التي يشملها نطاقك فقط.",
    "Only the lessons your scope reaches are listed.": "تُعرض الدروس التي يشملها نطاقك فقط.",
    "Only the person who delegated, the person holding the delegation, or an access administrator can revoke it.": "لا يستطيع إلغاءه إلا المفوِّض، أو حامل التفويض، أو مسؤول الصلاحيات.",
    "Only the person who recorded this lesson can reconcile its conflicts.": "لا يستطيع تسوية تعارضات هذا الدرس إلا من سجّله.",
    "Only what is ticked. A business unit includes all its projects.": "المحدَّد فقط. وحدة الأعمال تشمل كل مشاريعها.",
    "Only {0} more {1} {2} can be added. The rest were not taken.": "يمكن إضافة {0} {1} {2} فقط. لم يُؤخذ الباقي.",
    "Open": "فتح",
    "Open 0–15 days": "مفتوح 0–15 يومًا",
    "Open 15–45 days": "مفتوح 15–45 يومًا",
    "Open AI Settings": "فتح إعدادات الذكاء الاصطناعي",
    "Open SLA clocks and where they have escalated to.": "مؤقتات اتفاقية مستوى الخدمة المفتوحة وإلى أين صُعّدت.",
    "Open a monthly reporting period to enter figures, review the calculated index, and submit for approval.": "افتح فترة تقرير شهرية لإدخال الأرقام ومراجعة المؤشر المحسوب وتقديمه للاعتماد.",
    "Open a reporting period": "فتح فترة تقرير",
    "Open and closed": "مفتوحة ومغلقة",
    "Open and closed audits": "عمليات التدقيق المفتوحة والمغلقة",
    "Open clocks by state": "المؤقتات المفتوحة حسب الحالة",
    "Open corrective actions": "الإجراءات التصحيحية المفتوحة",
    "Open corrective actions by age": "الإجراءات التصحيحية المفتوحة حسب العمر",
    "Open corrective actions by how long they have been open, in the bands set in Master Data.": "الإجراءات التصحيحية المفتوحة حسب مدة بقائها مفتوحة، في الفئات المحددة في البيانات الرئيسية.",
    "Open escalations": "التصعيدات المفتوحة",
    "Open over 45 days": "مفتوح لأكثر من 45 يومًا",
    "Open the file": "فتح الملف",
    "Open the findings log": "فتح سجل الملاحظات",
    "Open the lesson": "فتح الدرس",
    "Opening": "افتتاحي",
    "Opening an existing period returns it rather than creating a second one.": "فتح فترة موجودة يعيدها بدلًا من إنشاء فترة ثانية.",
    "Opening and closing meetings": "الاجتماعان الافتتاحي والختامي",
    "Opening and closing minutes, evidence capture, findings.": "محاضر الافتتاح والختام، والتقاط الأدلة، والملاحظات.",
    "Opening meeting": "الاجتماع الافتتاحي",
    "Opening minutes": "محضر الاجتماع الافتتاحي",
    "Or write the version this record should hold": "أو اكتب النسخة التي يجب أن يحملها هذا السجل",
    "Org Admin": "مسؤول المنظمة",
    "Organisation": "المنظمة",
    "Outcome": "النتيجة",
    "Output price per million tokens": "سعر الإخراج لكل مليون رمز",
    "Over 45 days": "أكثر من 45 يومًا",
    "Over 45d": "أكثر من 45 يومًا",
    "Overage": "زيادة",
    "Overall": "الإجمالي",
    "Overall satisfaction": "الرضا العام",
    "Own": "الخاص",
    "Owner": "المالك",
    "Owner (optional)": "المالك (اختياري)",
    "PDF": "PDF",
    "PQI": "مؤشر الجودة",
    "Partly succeeded": "نجح جزئيًا",
    "Password": "كلمة المرور",
    "Passwords cannot be stored: the credential vault is not configured on this server.": "لا يمكن تخزين كلمات المرور: خزنة بيانات الاعتماد غير مُعدّة على هذا الخادم.",
    "Past target": "تجاوز المستهدف",
    "Paste the API key": "الصق مفتاح الواجهة البرمجية",
    "Paste the CSV": "الصق ملف CSV",
    "Pen": "قلم",
    "Pending days by responsible entity": "أيام الانتظار حسب الجهة المسؤولة",
    "Per project": "لكل مشروع",
    "Period": "الفترة",
    "Periods": "الفترات",
    "Permission": "الصلاحية",
    "Permission matrix for the new role": "مصفوفة صلاحيات الدور الجديد",
    "Permissions of": "صلاحيات",
    "Phase": "المرحلة",
    "Photo": "صورة",
    "Photo evidence": "أدلة مصورة",
    "Photo unavailable": "الصورة غير متاحة",
    "Photos": "الصور",
    "Plan": "الخطة",
    "Plan status": "حالة الخطة",
    "Planned": "مخطط",
    "Planned from": "مخطط من",
    "Planned start": "البداية المخططة",
    "Planned to": "مخطط إلى",
    "Platform": "المنصة",
    "Platform (sign-ins, access)": "المنصة (تسجيلات الدخول، الصلاحيات)",
    "Platform Role, Workspace Roles and their scope, and when each person last signed in.": "دور المنصة، وأدوار مساحة العمل ونطاقها، وآخر تسجيل دخول لكل شخص.",
    "Platform identifier": "مُعرِّف المنصة",
    "Platform project sync": "مزامنة مشاريع المنصة",
    "Platform role": "دور المنصة",
    "Platform-level entries — sign-ins, sessions, access changes — are for access administrators.": "السجلات على مستوى المنصة — تسجيلات الدخول والجلسات وتغييرات الصلاحيات — مخصصة لمسؤولي الصلاحيات.",
    "Port": "المنفذ",
    "Positive": "إيجابي",
    "Preparing…": "جارٍ التجهيز…",
    "Price: {0} in / {1} out {2} per million tokens.": "السعر: {0} للإدخال / {1} للإخراج {2} لكل مليون رمز.",
    "Priority": "الأولوية",
    "Process / Product Owner": "مالك العملية / المنتج",
    "Programme": "البرنامج",
    "Project": "المشروع",
    "Project Quality Index": "مؤشر جودة المشروع",
    "Project Quality Index weighting": "أوزان مؤشر جودة المشروع",
    "Project code": "رمز المشروع",
    "Project group": "مجموعة المشاريع",
    "Project name": "اسم المشروع",
    "Project name (Arabic)": "اسم المشروع (بالعربية)",
    "Projects": "المشاريع",
    "Provider": "المزوّد",
    "Provisional weighting.": "أوزان مؤقتة.",
    "Provisional — this audit is not finished": "مؤقت — لم ينتهِ هذا التدقيق",
    "Provisional: {0}": "مؤقت: {0}",
    "Push": "الإشعارات الفورية",
    "Push could not be switched off for this device.": "تعذّر إيقاف الإشعارات الفورية لهذا الجهاز.",
    "Push could not be switched on for this device.": "تعذّر تفعيل الإشعارات الفورية لهذا الجهاز.",
    "Push delivery": "تسليم الإشعارات الفورية",
    "Push is not set up on this server yet.": "الإشعارات الفورية غير مُعدّة على هذا الخادم بعد.",
    "Push on this device": "الإشعارات الفورية على هذا الجهاز",
    "Push switched on": "تم تفعيل الإشعارات الفورية",
    "Push to this device": "إرسال إلى هذا الجهاز",
    "QA/QC": "ضمان الجودة/مراقبة الجودة",
    "QA/QC & Document Governance": "ضمان الجودة/مراقبة الجودة وحوكمة الوثائق",
    "QA/QC Dashboard": "لوحة ضمان الجودة/مراقبة الجودة",
    "QA/QC Metrics": "مقاييس ضمان الجودة/مراقبة الجودة",
    "QA/QC reporting periods matching the selected filters": "فترات تقارير ضمان الجودة/مراقبة الجودة المطابقة لعوامل التصفية المحددة",
    "QAQC Metrics": "مقاييس ضمان الجودة/مراقبة الجودة",
    "QAQC Representative": "ممثل ضمان الجودة/مراقبة الجودة",
    "QMS Audit": "تدقيق نظام إدارة الجودة",
    "QMS Audit Management": "إدارة تدقيق نظام إدارة الجودة",
    "QMS360": "QMS360",
    "Quality": "الجودة",
    "Quality Assessment Brief": "موجز تقييم الجودة",
    "Quality Manager": "مدير الجودة",
    "Quality Toolbox Talks": "اجتماعات الجودة التوعوية",
    "Quality assessment brief": "موجز تقييم الجودة",
    "Quality index": "مؤشر الجودة",
    "Quality toolbox talks": "اجتماعات الجودة التوعوية",
    "Quarterly": "ربع سنوي",
    "Question": "السؤال",
    "Queued": "في قائمة الانتظار",
    "RFI": "طلبات المعلومات (RFI)",
    "RMI": "فحص المواد (RMI)",
    "Raise a finding": "تسجيل ملاحظة",
    "Raise a finding from this": "سجّل ملاحظة من هذا",
    "Raise it": "سجّلها",
    "Raised": "سُجّلت",
    "Read": "قراءة",
    "Read the audits you are invited to, until your invitation ends or the audit closes.": "اقرأ عمليات التدقيق المدعو إليها، حتى تنتهي دعوتك أو يُغلق التدقيق.",
    "Reading the audit log needs access administration, or View All across an application.": "قراءة سجل التدقيق تحتاج إلى صلاحية إدارة الوصول، أو صلاحية عرض الكل في تطبيق.",
    "Reading…": "جارٍ القراءة…",
    "Recent entries": "أحدث السجلات",
    "Recent periods": "أحدث الفترات",
    "Recipients' email addresses": "عناوين البريد الإلكتروني للمستلمين",
    "Reconcile changes": "تسوية التغييرات",
    "Record": "تسجيل",
    "Record id": "مُعرِّف السجل",
    "Record observation": "تسجيل المشاهدة",
    "Record the opening meeting before raising findings — the audit has not started.": "سجّل الاجتماع الافتتاحي قبل تسجيل الملاحظات — لم يبدأ التدقيق.",
    "Record the opening meeting before the closing meeting — the audit has not formally started.": "سجّل الاجتماع الافتتاحي قبل الختامي — لم يبدأ التدقيق رسميًا.",
    "Record type": "نوع السجل",
    "Record whether the AI draft was accepted, edited or rejected before saving.": "سجّل ما إذا قُبلت مسودة الذكاء الاصطناعي أو عُدّلت أو رُفضت قبل الحفظ.",
    "Record whether the rewrite was accepted, edited or rejected before saving.": "سجّل ما إذا قُبلت إعادة الصياغة أو عُدّلت أو رُفضت قبل الحفظ.",
    "Recorded": "سُجّل",
    "Recorded as coming from": "سُجّل على أنه وارد من",
    "Records the sync could not use": "سجلات لم تتمكن المزامنة من استخدامها",
    "Recurrence window (months)": "نافذة التكرار (بالأشهر)",
    "Recurring nonconformities": "حالات عدم المطابقة المتكررة",
    "Reference": "المرجع",
    "Reject": "رفض",
    "Rejected": "مرفوض",
    "Remarks (required to send back)": "الملاحظات (مطلوبة للإعادة)",
    "Remind (working days before)": "التذكير (أيام عمل قبل)",
    "Reminded roles": "الأدوار التي تُذكَّر",
    "Reminder before the deadline": "تذكير قبل الموعد النهائي",
    "Reminders reach only the person the clock runs against. For an approval, name the approver role.": "تصل التذكيرات إلى الشخص الذي يسري عليه المؤقت فقط. في حالة الاعتماد، حدّد دور المعتمِد.",
    "Reminders, overdue items and escalations from all three applications.": "التذكيرات والعناصر المتأخرة والتصعيدات من التطبيقات الثلاثة.",
    "Remove": "إزالة",
    "Repeat location": "موقع التكرار",
    "Repeated": "متكرر",
    "Repeated issue": "مشكلة متكررة",
    "Rephrase the narrative fields": "إعادة صياغة الحقول السردية",
    "Rephrase with AI": "إعادة الصياغة بالذكاء الاصطناعي",
    "Replace signing keys": "استبدال مفاتيح التوقيع",
    "Replace the key": "استبدال المفتاح",
    "Replace them": "استبدلها",
    "Report": "التقرير",
    "Report period": "فترة التقرير",
    "Reports": "التقارير",
    "Reports that go out by themselves from": "تقارير تُرسل تلقائيًا من",
    "Reports waiting on approval. You cannot approve one you submitted yourself.": "تقارير تنتظر الاعتماد. لا يمكنك اعتماد تقرير قدّمته بنفسك.",
    "Request an extension. It changes nothing until the Audit Lead approves it — the current date stands until then.": "اطلب تمديدًا. لا يتغير شيء حتى يعتمده قائد التدقيق — يبقى التاريخ الحالي ساريًا حتى ذلك الحين.",
    "Request extension": "طلب تمديد",
    "Request id": "مُعرِّف الطلب",
    "Required. This is what the author will see, so it has to be enough to act on.": "مطلوب. هذا ما سيراه كاتب الدرس، لذا يجب أن يكفي للتصرف بناءً عليه.",
    "Reset": "إعادة تعيين",
    "Reset password": "إعادة تعيين كلمة المرور",
    "Resetting…": "جارٍ إعادة التعيين…",
    "Resolved": "تمت المعالجة",
    "Respondent (optional)": "المستجيب (اختياري)",
    "Respondents": "المستجيبون",
    "Responsible department": "الإدارة المسؤولة",
    "Responsiveness": "سرعة الاستجابة",
    "Resubmit": "إعادة تقديم",
    "Retention: entries stay online for {0} months, after which they may be archived. Entries are never deleted.": "الاحتفاظ: تبقى السجلات متاحة {0} شهرًا، ويجوز بعدها أرشفتها. لا تُحذف السجلات أبدًا.",
    "Retention: no period set — every entry stays online. Entries are never deleted.": "الاحتفاظ: لم تُحدَّد مدة — يبقى كل سجل متاحًا. لا تُحذف السجلات أبدًا.",
    "Retire": "إيقاف",
    "Retire this list? Nothing more is sent to it; what was sent stays on record.": "إيقاف هذه القائمة؟ لن يُرسل إليها شيء بعد الآن؛ ويبقى ما أُرسل مسجلًا.",
    "Retire {0}? Past records keep it; it stops being offered.": "إيقاف {0}؟ تحتفظ به السجلات السابقة؛ ويتوقف عرضه.",
    "Retiring is never a deletion — the row keeps its history, existing records still resolve, and the code becomes available again.": "الإيقاف ليس حذفًا أبدًا — يحتفظ الصف بتاريخه، وتبقى السجلات الحالية صحيحة، ويصبح الرمز متاحًا مجددًا.",
    "Review days (total)": "أيام المراجعة (الإجمالي)",
    "Reviews completed": "المراجعات المكتملة",
    "Revoke": "إلغاء",
    "Rewrite accepted and saved.": "قُبلت إعادة الصياغة وحُفظت.",
    "Rewrite rejected. Your own wording is kept.": "رُفضت إعادة الصياغة. احتُفظ بصياغتك.",
    "Risk": "المخاطر",
    "Risk level": "مستوى المخاطر",
    "Risk:": "المخاطر:",
    "Role assignment": "إسناد الدور",
    "Role builder": "منشئ الأدوار",
    "Role name": "اسم الدور",
    "Root cause": "السبب الجذري",
    "Root cause — what went wrong": "السبب الجذري — ما الذي حدث خطأ",
    "Root cause:": "السبب الجذري:",
    "Root element missing from index.html.": "العنصر الجذري مفقود من index.html.",
    "Run by itself every (minutes; empty = only by hand)": "تشغيل تلقائي كل (دقائق؛ فارغ = يدويًا فقط)",
    "Run now": "شغّل الآن",
    "Running": "قيد التشغيل",
    "Running the platform sync changes project master data through a shared connection, so it needs integration authority in all three applications and configuration authority over master data.": "تشغيل مزامنة المنصة يغيّر البيانات الرئيسية للمشاريع عبر اتصال مشترك، لذا يحتاج إلى صلاحية التكامل في التطبيقات الثلاثة وصلاحية إعداد البيانات الرئيسية.",
    "Running the report…": "جارٍ تشغيل التقرير…",
    "Running…": "جارٍ التشغيل…",
    "Runs against": "يسري على",
    "SLA (working days)": "اتفاقية مستوى الخدمة (أيام عمل)",
    "SMS": "رسائل نصية",
    "STARTTLS (usually port 587)": "STARTTLS (عادةً المنفذ 587)",
    "Sandbox": "البيئة التجريبية",
    "Sandbox (dry runs only)": "البيئة التجريبية (تشغيل تجريبي فقط)",
    "Sandbox address": "عنوان البيئة التجريبية",
    "Sandbox is on, so nothing is applied. Switch sandbox off to apply this record.": "البيئة التجريبية مفعّلة، لذا لا يُطبَّق شيء. أوقف البيئة التجريبية لتطبيق هذا السجل.",
    "Sandbox is on: every message goes to": "البيئة التجريبية مفعّلة: كل رسالة تذهب إلى",
    "Sandbox mode sends every message to one address. Give that address first.": "وضع البيئة التجريبية يرسل كل رسالة إلى عنوان واحد. أدخل ذلك العنوان أولًا.",
    "Sat": "السبت",
    "Save": "حفظ",
    "Save as a new version": "حفظ كإصدار جديد",
    "Save brief": "حفظ الموجز",
    "Save changes": "حفظ التغييرات",
    "Save draft": "حفظ المسودة",
    "Save entry": "حفظ السجل",
    "Save key": "حفظ المفتاح",
    "Save my edit": "حفظ تعديلي",
    "Save my version": "حفظ نسختي",
    "Save on this device": "حفظ على هذا الجهاز",
    "Save permissions": "حفظ الصلاحيات",
    "Save price": "حفظ السعر",
    "Save scope": "حفظ النطاق",
    "Save settings": "حفظ الإعدادات",
    "Save the finding": "حفظ الملاحظة",
    "Save the lesson first — a photo has to know which record it belongs to.": "احفظ الدرس أولًا — يجب أن تعرف الصورة السجل الذي تنتمي إليه.",
    "Save the lesson first.": "احفظ الدرس أولًا.",
    "Save the marks": "حفظ العلامات",
    "Save the platform sync settings before its mapping.": "احفظ إعدادات مزامنة المنصة قبل تعيينها.",
    "Save the team": "حفظ الفريق",
    "Save the working week": "حفظ أسبوع العمل",
    "Save wording": "حفظ الصياغة",
    "Saved as your edit of the rewrite.": "حُفظ بوصفه تعديلك لإعادة الصياغة.",
    "Saved as {0}.": "حُفظ بصفة {0}.",
    "Saved on this device — the server could not be reached.": "حُفظ على هذا الجهاز — تعذّر الوصول إلى الخادم.",
    "Saved on this device. It will sync when you have a signal.": "حُفظ على هذا الجهاز. ستتم مزامنته عندما تتوفر إشارة.",
    "Saving adds a new version; every run records the version it used.": "الحفظ يضيف إصدارًا جديدًا؛ ويسجّل كل تشغيل الإصدار الذي استخدمه.",
    "Saving…": "جارٍ الحفظ…",
    "Say what needs changing.": "اذكر ما الذي يحتاج إلى تغيير.",
    "Say which application.": "حدّد التطبيق.",
    "Say which device.": "حدّد الجهاز.",
    "Say why this record is being set aside.": "اذكر سبب تنحية هذا السجل.",
    "Scheduled report": "تقرير مجدول",
    "Scheduled report could not run": "تعذّر تشغيل التقرير المجدول",
    "Scope": "النطاق",
    "Scope and criteria": "النطاق والمعايير",
    "Scope — what is being audited": "النطاق — ما الذي يُدقَّق",
    "Scope, criteria, date and location — shared with the Process and Product Owners before the audit begins.": "النطاق والمعايير والتاريخ والموقع — تُشارَك مع مالكي العمليات والمنتجات قبل بدء التدقيق.",
    "Scope, criteria, date and location, shared with process owners.": "النطاق والمعايير والتاريخ والموقع، تُشارَك مع مالكي العمليات.",
    "Search": "بحث",
    "Search record or person": "ابحث عن سجل أو شخص",
    "Searchable, filterable knowledge base of every approved lesson.": "قاعدة معرفة قابلة للبحث والتصفية لكل درس معتمد.",
    "Security": "الأمان",
    "See the outbox": "عرض صندوق الصادر",
    "Select": "اختيار",
    "Send again": "إرسال مرة أخرى",
    "Send as (address)": "الإرسال باسم (العنوان)",
    "Send as (name)": "الإرسال باسم (الاسم)",
    "Send back": "إعادة للمراجعة",
    "Send project names to the provider (otherwise only project codes)": "إرسال أسماء المشاريع إلى المزوّد (وإلا فرموز المشاريع فقط)",
    "Sending back…": "جارٍ الإعادة…",
    "Sending email uses the connection all three applications share, so it needs integration authority in all three.": "إرسال البريد الإلكتروني يستخدم الاتصال المشترك بين التطبيقات الثلاثة، لذا يحتاج إلى صلاحية التكامل في الثلاثة.",
    "Sends what is approved after {0}.": "يرسل ما يُعتمد بعد {0}.",
    "Sent Back": "أُعيد للمراجعة",
    "Sent back": "أُعيد للمراجعة",
    "Sent back for revision.": "أُعيد للمراجعة لإجراء تعديلات.",
    "Sent back with": "أُعيد للمراجعة مع",
    "Sent back:": "أُعيد للمراجعة:",
    "Sent when it is approved — one message per approval, to everyone on the list.": "يُرسل عند اعتماده — رسالة واحدة لكل اعتماد، إلى كل من في القائمة.",
    "Sent — accepted by the mail server": "أُرسل — قبله خادم البريد",
    "Session expired. Sign in again.": "انتهت الجلسة. سجّل الدخول مرة أخرى.",
    "Session has been revoked. Sign in again.": "أُلغيت الجلسة. سجّل الدخول مرة أخرى.",
    "Sessions": "الجلسات",
    "Set aside": "تنحية جانبًا",
    "Settings": "الإعدادات",
    "Severity": "الخطورة",
    "Share with process owners": "مشاركة مع مالكي العمليات",
    "Shared": "مُشارَك",
    "Shared across all three applications. Nothing here needs a deployment to change — that is the point of it.": "مشترك بين التطبيقات الثلاثة. لا شيء هنا يحتاج إلى نشر جديد لتغييره — وهذا هو الغرض منه.",
    "Shared by all three applications. A key is never shown again once saved — only its last four characters.": "مشترك بين التطبيقات الثلاثة. لا يُعرض المفتاح أبدًا بعد حفظه — بل آخر أربعة أحرف منه فقط.",
    "Shared once, deliberately. Re-issuing a changed plan is a new act, so that the date people were actually told is not overwritten.": "تُشارَك مرة واحدة عمدًا. إعادة إصدار خطة معدّلة إجراء جديد، حتى لا يُستبدل التاريخ الذي أُبلغ فيه الناس فعلًا.",
    "Shared with owners": "مُشارَك مع المالكين",
    "Shortage": "نقص",
    "Show": "عرض",
    "Show AI activity": "عرض نشاط الذكاء الاصطناعي",
    "Showing the copy held on this device. It has not synced yet.": "يُعرض النسخة المحفوظة على هذا الجهاز. لم تتم مزامنتها بعد.",
    "Showing the copy held on this device. Reconnect to search the full log.": "يُعرض النسخة المحفوظة على هذا الجهاز. أعد الاتصال للبحث في السجل الكامل.",
    "Sign in": "تسجيل الدخول",
    "Sign in failed.": "فشل تسجيل الدخول.",
    "Sign in to QMS360": "تسجيل الدخول إلى QMS360",
    "Sign out": "تسجيل الخروج",
    "Sign out instead": "سجّل الخروج بدلًا من ذلك",
    "Sign-in": "تسجيل الدخول",
    "Sign-off": "الاعتماد والتوقيع",
    "Signed in with": "تم تسجيل الدخول باستخدام",
    "Signing in…": "جارٍ تسجيل الدخول…",
    "Signing keys:": "مفاتيح التوقيع:",
    "Six rated questions and free-text feedback, averaged per month.": "ستة أسئلة مقيّمة وملاحظات نصية، بمتوسط شهري.",
    "Skip to the content": "انتقل إلى المحتوى",
    "Some CAR owners are not users in this organisation.": "بعض مالكي الإجراءات التصحيحية ليسوا مستخدمين في هذه المنظمة.",
    "Some audit team members are not users in this organisation.": "بعض أعضاء فريق التدقيق ليسوا مستخدمين في هذه المنظمة.",
    "Some business units are not in this organisation.": "بعض وحدات الأعمال ليست في هذه المنظمة.",
    "Some departments are not business units in this organisation.": "بعض الإدارات ليست وحدات أعمال في هذه المنظمة.",
    "Some of these departments already have a current corrective action for this finding. A follow-up is issued only after one is verified not effective.": "لبعض هذه الإدارات إجراء تصحيحي قائم لهذه الملاحظة بالفعل. لا تصدر متابعة إلا بعد التحقق من أن الإجراء غير فعّال.",
    "Some projects are not in this organisation.": "بعض المشاريع ليست في هذه المنظمة.",
    "Someone with a QMS360 account at that address also sees it in the app, in their own language. Anyone else gets the email only, in English, with the report attached.": "من لديه حساب QMS360 بذلك العنوان يراه أيضًا داخل التطبيق، بلغته. أما غيره فيصله البريد الإلكتروني فقط، بالإنجليزية، مع إرفاق التقرير.",
    "Something went wrong.": "حدث خطأ ما.",
    "Something went wrong. Quote the request id if you report this.": "حدث خطأ ما. اذكر مُعرِّف الطلب إن أبلغت عن ذلك.",
    "Source IP": "عنوان IP المصدر",
    "Start a programme": "بدء برنامج",
    "Start an audit": "بدء تدقيق",
    "Started": "بدأ",
    "State": "الحالة",
    "Status": "الحالة",
    "Status breakdown reconciles to the MIRN total ({0}).": "توزيع الحالات يطابق إجمالي MIRN ({0}).",
    "Status breakdown reconciles to the {0} documents recorded.": "توزيع الحالات يطابق الوثائق المسجلة وعددها {0}.",
    "Status breakdown totals {0} against a MIRN total of {1}. This must match before the report can be submitted.": "مجموع توزيع الحالات {0} مقابل إجمالي MIRN البالغ {1}. يجب أن يتطابقا قبل تقديم التقرير.",
    "Status breakdown totals {0} against {1} documents. This must match before the entry can be submitted.": "مجموع توزيع الحالات {0} مقابل {1} وثيقة. يجب أن يتطابقا قبل تقديم السجل.",
    "Status: {0}": "الحالة: {0}",
    "Still outstanding — all of it, not just the first:": "لا يزال معلّقًا — كله، لا الأول فقط:",
    "Store password": "تخزين كلمة المرور",
    "Store token": "تخزين الرمز",
    "Stored credential": "بيانات اعتماد مخزّنة",
    "Subject": "الموضوع",
    "Submission needs a connection. Your entry is saved on this device.": "التقديم يحتاج إلى اتصال. حُفظ إدخالك على هذا الجهاز.",
    "Submit": "تقديم",
    "Submit for approval": "تقديم للاعتماد",
    "Submit for verification": "تقديم للتحقق",
    "Submittals": "التقديمات",
    "Submitted": "مُقدَّم",
    "Submitted by": "قدّمه",
    "Submitted for verification": "قُدّم للتحقق",
    "Submitting needs a connection. Your entry is safe on this device.": "التقديم يحتاج إلى اتصال. إدخالك آمن على هذا الجهاز.",
    "Submitting…": "جارٍ التقديم…",
    "Succeeded": "نجح",
    "Suggested": "مقترح",
    "Suggested rewrite of {0}": "إعادة صياغة مقترحة لـ {0}",
    "Suggested rewrite — yours until you choose": "إعادة صياغة مقترحة — ملكك حتى تختار",
    "Suggestions per month": "الاقتراحات في الشهر",
    "Suggestions this month: {0}{1}. When the quota is reached, forms carry on by hand until the 1st.": "الاقتراحات هذا الشهر: {0}{1}. عند بلوغ الحصة، تستمر النماذج يدويًا حتى أول الشهر.",
    "Summary": "الملخص",
    "Sun": "الأحد",
    "Super Admin": "المسؤول الأعلى",
    "Survey response": "رد الاستبيان",
    "Switch application": "تبديل التطبيق",
    "Switch off": "إيقاف",
    "Switch on": "تفعيل",
    "Switched off by the reader": "أوقفه القارئ",
    "Switched off: nothing is sent.": "معطّل: لا يُرسل شيء.",
    "Switched on — it will run as you, with your export authority, checked again on every run.": "مفعّل — سيعمل باسمك، بصلاحية التصدير الخاصة بك، ويُتحقق منها مجددًا في كل تشغيل.",
    "Sync now": "مزامنة الآن",
    "Sync switched on": "تم تفعيل المزامنة",
    "Synced": "تمت المزامنة",
    "Synced from the {0}. Read-only here: projects are created on the platform, and arrive here by the sync.": "متزامن من {0}. للقراءة فقط هنا: تُنشأ المشاريع على المنصة وتصل إلى هنا عبر المزامنة.",
    "Syncing…": "جارٍ المزامنة…",
    "System": "النظام",
    "TLS (usually port 465)": "TLS (عادةً المنفذ 465)",
    "Take or choose a {0} photo": "التقط أو اختر صورة {0}",
    "Target": "المستهدف",
    "Target benchmarks": "المستهدفات المرجعية",
    "Target completion": "الإنجاز المستهدف",
    "Team": "الفريق",
    "Team: {0}.": "الفريق: {0}.",
    "Template": "القالب",
    "Temporary password": "كلمة مرور مؤقتة",
    "Temporary password for": "كلمة مرور مؤقتة لـ",
    "Test connection": "اختبار الاتصال",
    "Test message:": "رسالة الاختبار:",
    "Testing…": "جارٍ الاختبار…",
    "Text": "نص",
    "Text, then tap the photo": "النص، ثم انقر على الصورة",
    "That answer could not be saved.": "تعذّر حفظ تلك الإجابة.",
    "That application does not exist.": "ذلك التطبيق غير موجود.",
    "That audit could not be created.": "تعذّر إنشاء ذلك التدقيق.",
    "That audit could not be loaded.": "تعذّر تحميل ذلك التدقيق.",
    "That business unit could not be saved.": "تعذّر حفظ وحدة الأعمال تلك.",
    "That checklist answer has already produced a finding.": "أنتجت إجابة قائمة التحقق تلك ملاحظة بالفعل.",
    "That corrective action could not be issued.": "تعذّر إصدار ذلك الإجراء التصحيحي.",
    "That could not be approved.": "تعذّر الاعتماد.",
    "That could not be done.": "تعذّر تنفيذ ذلك.",
    "That could not be resolved.": "تعذّرت التسوية.",
    "That could not be retired.": "تعذّر الإيقاف.",
    "That could not be saved.": "تعذّر الحفظ.",
    "That could not be sent back.": "تعذّرت الإعادة للمراجعة.",
    "That could not be submitted.": "تعذّر التقديم.",
    "That could not be verified.": "تعذّر التحقق.",
    "That delegation could not be created.": "تعذّر إنشاء ذلك التفويض.",
    "That delegation could not be revoked.": "تعذّر إلغاء ذلك التفويض.",
    "That delegation is already revoked.": "ذلك التفويض مُلغى بالفعل.",
    "That device is not subscribed.": "ذلك الجهاز غير مشترك.",
    "That discipline could not be saved.": "تعذّر حفظ ذلك التخصص.",
    "That distribution list does not exist.": "قائمة التوزيع تلك غير موجودة.",
    "That escalation rule could not be saved.": "تعذّر حفظ قاعدة التصعيد تلك.",
    "That evidence could not be saved.": "تعذّر حفظ ذلك الدليل.",
    "That extension could not be approved.": "تعذّر اعتماد ذلك التمديد.",
    "That extension could not be requested.": "تعذّر طلب ذلك التمديد.",
    "That extension has already been approved.": "ذلك التمديد معتمد بالفعل.",
    "That file belongs to another organisation.": "ذلك الملف يخص منظمة أخرى.",
    "That file could not be attached.": "تعذّر إرفاق ذلك الملف.",
    "That file could not be read.": "تعذّرت قراءة ذلك الملف.",
    "That file is attached to nothing you can see.": "ذلك الملف غير مرفق بأي شيء يمكنك رؤيته.",
    "That file is not a PDF.": "ذلك الملف ليس PDF.",
    "That file is not an Excel workbook. Upload the .xlsx file QMS360 exported for this month.": "ذلك الملف ليس مصنف Excel. ارفع ملف ‎.xlsx الذي صدّره QMS360 لهذا الشهر.",
    "That finding could not be changed.": "تعذّر تغيير تلك الملاحظة.",
    "That finding could not be raised.": "تعذّر تسجيل تلك الملاحظة.",
    "That guest is already invited to this audit. Revoke the invitation to change it.": "ذلك الزائر مدعو إلى هذا التدقيق بالفعل. ألغِ الدعوة لتغييرها.",
    "That holiday could not be added.": "تعذّرت إضافة تلك العطلة.",
    "That identifier is already in use.": "ذلك المُعرِّف مستخدم بالفعل.",
    "That is not a document id.": "هذا ليس مُعرِّف مستند.",
    "That is not a message id.": "هذا ليس مُعرِّف رسالة.",
    "That is not a notification channel.": "هذه ليست قناة إشعارات.",
    "That is not a notification id.": "هذا ليس مُعرِّف إشعار.",
    "That is not a push subscription.": "هذا ليس اشتراكًا في الإشعارات الفورية.",
    "That message could not be marked read.": "تعذّر تعليم تلك الرسالة كمقروءة.",
    "That message was not found.": "لم يُعثر على تلك الرسالة.",
    "That notification was not found.": "لم يُعثر على ذلك الإشعار.",
    "That photo could not be prepared. Try taking it again.": "تعذّر تجهيز تلك الصورة. حاول التقاطها مرة أخرى.",
    "That plan could not be saved.": "تعذّر حفظ تلك الخطة.",
    "That plan could not be shared.": "تعذّرت مشاركة تلك الخطة.",
    "That platform role could not be changed.": "تعذّر تغيير دور المنصة ذلك.",
    "That project is not in this organisation.": "ذلك المشروع ليس في هذه المنظمة.",
    "That push service is not one this server sends to.": "خدمة الإشعارات الفورية تلك ليست من الخدمات التي يرسل إليها هذا الخادم.",
    "That record has already been dealt with.": "تمت معالجة ذلك السجل بالفعل.",
    "That report could not be generated. You may not have export authority for this audit.": "تعذّر إنشاء ذلك التقرير. قد لا تملك صلاحية التصدير لهذا التدقيق.",
    "That report is for a project outside what you can see.": "ذلك التقرير لمشروع خارج ما يمكنك رؤيته.",
    "That role could not be changed.": "تعذّر تغيير ذلك الدور.",
    "That role could not be created.": "تعذّر إنشاء ذلك الدور.",
    "That role could not be granted.": "تعذّر منح ذلك الدور.",
    "That role could not be revoked.": "تعذّر سحب ذلك الدور.",
    "That run was not found.": "لم يُعثر على ذلك التشغيل.",
    "That schedule could not be approved.": "تعذّر اعتماد ذلك الجدول.",
    "That schedule could not be created.": "تعذّر إنشاء ذلك الجدول.",
    "That schedule could not be sent back.": "تعذّرت إعادة ذلك الجدول للمراجعة.",
    "That schedule could not be submitted.": "تعذّر تقديم ذلك الجدول.",
    "That scope could not be changed.": "تعذّر تغيير ذلك النطاق.",
    "That setup token is not right.": "رمز الإعداد ذلك غير صحيح.",
    "That sync error was not found.": "لم يُعثر على خطأ المزامنة ذلك.",
    "That target could not be saved.": "تعذّر حفظ ذلك المستهدف.",
    "That user is not in this organisation.": "ذلك المستخدم ليس في هذه المنظمة.",
    "That weighting could not be saved.": "تعذّر حفظ تلك الأوزان.",
    "That workbook is larger than any month QMS360 exports. Start from this month’s export.": "ذلك المصنف أكبر من أي شهر يصدّره QMS360. ابدأ من تصدير هذا الشهر.",
    "The AI settings could not be saved.": "تعذّر حفظ إعدادات الذكاء الاصطناعي.",
    "The Data Sync Cockpit needs integration authority. Ask an administrator if you need it.": "مركز مزامنة البيانات يحتاج إلى صلاحية التكامل. اطلبها من مسؤول إن احتجت إليها.",
    "The Executive 360 view is for access administrators and people who can view all records in all three applications.": "عرض الرؤية التنفيذية 360 مخصص لمسؤولي الصلاحيات ولمن يمكنه عرض كل السجلات في التطبيقات الثلاثة.",
    "The Integration Cockpit needs integration authority. Ask an administrator if you need it.": "مركز التكامل يحتاج إلى صلاحية التكامل. اطلبها من مسؤول إن احتجت إليها.",
    "The Lesson Learned Log — filter it to the lessons you raised.": "سجل الدروس المستفادة — صفِّه لعرض الدروس التي سجّلتها.",
    "The PDF could not be made.": "تعذّر إنشاء ملف PDF.",
    "The Quality Index formula is pending Algihaz confirmation.": "معادلة مؤشر الجودة بانتظار تأكيد Algihaz.",
    "The account could not be created.": "تعذّر إنشاء الحساب.",
    "The app shell is not running in this window.": "هيكل التطبيق لا يعمل في هذه النافذة.",
    "The approval memo is a PDF.": "مذكرة الاعتماد ملف PDF.",
    "The audit": "التدقيق",
    "The audit team is set before the audit starts. This audit has already moved past Pre-Audit.": "يُحدَّد فريق التدقيق قبل بدء التدقيق. تجاوز هذا التدقيق مرحلة ما قبل التدقيق بالفعل.",
    "The brief references an AI draft without recording what was done with it.": "يشير الموجز إلى مسودة ذكاء اصطناعي دون تسجيل ما تم بها.",
    "The checklist could not be created.": "تعذّر إنشاء قائمة التحقق.",
    "The closing meeting cannot be earlier than the opening meeting.": "لا يمكن أن يكون الاجتماع الختامي قبل الافتتاحي.",
    "The credential vault is not configured on this server. Ask whoever runs it to set CREDENTIALS_KEY.": "خزنة بيانات الاعتماد غير مُعدّة على هذا الخادم. اطلب من مشغّله ضبط CREDENTIALS_KEY.",
    "The current weighting is marked": "الأوزان الحالية موسومة بأنها",
    "The dashboard could not be loaded.": "تعذّر تحميل لوحة المتابعة.",
    "The delegation could not be ended.": "تعذّر إنهاء التفويض.",
    "The delegation could not be made.": "تعذّر إنشاء التفويض.",
    "The demonstration provider writes fixed text from the figures. It is for trying the screens, not for real records.": "مزوّد العرض التوضيحي يكتب نصًا ثابتًا من الأرقام. إنه لتجربة الشاشات، لا للسجلات الحقيقية.",
    "The department decides": "تقرر الإدارة",
    "The direction is asked for rather than assumed: a target with it the wrong way round reports success exactly when things are at their worst.": "يُطلب الاتجاه بدلًا من افتراضه: المستهدف ذو الاتجاه المعكوس يُظهر النجاح تمامًا عندما تكون الأمور في أسوأ حالاتها.",
    "The distribution view. Aggregated across the window, not approved as a unit.": "عرض التوزيع. مُجمَّع عبر الفترة، ولا يُعتمد كوحدة واحدة.",
    "The draft could not be made.": "تعذّر إنشاء المسودة.",
    "The email settings could not be saved.": "تعذّر حفظ إعدادات البريد الإلكتروني.",
    "The end date must be in the future.": "يجب أن يكون تاريخ الانتهاء في المستقبل.",
    "The file could not be read on this device.": "تعذّرت قراءة الملف على هذا الجهاز.",
    "The file could not be read.": "تعذّرت قراءة الملف.",
    "The four weights must add up to exactly 1, or every index is quietly wrong.": "يجب أن يكون مجموع الأوزان الأربعة 1 تمامًا، وإلا فكل مؤشر خاطئ دون أن يلاحظ أحد.",
    "The guest could not be invited.": "تعذّرت دعوة الزائر.",
    "The incoming version was written on a device at": "كُتبت النسخة الواردة على جهاز في",
    "The index formula is not defined in the approved specification. These weights are a starting point pending Algihaz confirmation, and the figure should be read with that in mind.": "معادلة المؤشر غير محددة في المواصفات المعتمدة. هذه الأوزان نقطة بداية بانتظار تأكيد Algihaz، ويجب قراءة الرقم مع مراعاة ذلك.",
    "The invitation could not be revoked.": "تعذّر إلغاء الدعوة.",
    "The issued report could not be opened.": "تعذّر فتح التقرير الصادر.",
    "The key could not be removed.": "تعذّرت إزالة المفتاح.",
    "The key could not be saved.": "تعذّر حفظ المفتاح.",
    "The keys could not be generated.": "تعذّر إنشاء المفاتيح.",
    "The last six months. Costs use the price in force when each suggestion was made.": "آخر ستة أشهر. تُحسب التكاليف بالسعر الساري عند تقديم كل اقتراح.",
    "The lesson": "الدرس",
    "The mapping could not be saved.": "تعذّر حفظ التعيين.",
    "The marks could not be saved. Drawing needs a signal.": "تعذّر حفظ العلامات. الرسم يحتاج إلى إشارة.",
    "The material inspection could not be saved.": "تعذّر حفظ فحص المواد.",
    "The memo PDF is not ready yet.": "ملف PDF للمذكرة غير جاهز بعد.",
    "The memo could not be opened.": "تعذّر فتح المذكرة.",
    "The memo is being prepared — the distribution job makes it shortly after approval.": "جارٍ إعداد المذكرة — تُنشئها مهمة التوزيع بعد الاعتماد بوقت قصير.",
    "The memo is kept as a PDF but has not been sent — see the email outbox.": "حُفظت المذكرة بصيغة PDF لكنها لم تُرسل — راجع صندوق البريد الصادر.",
    "The message could not be queued.": "تعذّر وضع الرسالة في قائمة الانتظار.",
    "The opening meeting cannot be later than the closing meeting.": "لا يمكن أن يكون الاجتماع الافتتاحي بعد الختامي.",
    "The outbox is not available to your role.": "صندوق الصادر غير متاح لدورك.",
    "The password could not be removed.": "تعذّرت إزالة كلمة المرور.",
    "The password could not be reset.": "تعذّرت إعادة تعيين كلمة المرور.",
    "The password could not be stored.": "تعذّر تخزين كلمة المرور.",
    "The photo itself is kept as it was taken; your marks are saved beside it.": "تُحفظ الصورة نفسها كما التُقطت؛ وتُحفظ علاماتك إلى جانبها.",
    "The planned end date is before the planned start date.": "تاريخ الانتهاء المخطط قبل تاريخ البدء المخطط.",
    "The platform project sync and every job that runs by itself: runs, what they found, the error queue, and the field mapping.": "مزامنة مشاريع المنصة وكل مهمة تعمل تلقائيًا: التشغيلات، وما وجدته، وقائمة الأخطاء، وتعيين الحقول.",
    "The platform project sync, and every job that runs by itself. The sync's connection is set up in the": "مزامنة مشاريع المنصة، وكل مهمة تعمل تلقائيًا. يُعدّ اتصال المزامنة في",
    "The platform sign-in could not be verified.": "تعذّر التحقق من تسجيل الدخول عبر المنصة.",
    "The platform sync is already running.": "مزامنة المنصة قيد التشغيل بالفعل.",
    "The platform sync is not set up yet. Save its settings in the Integration Cockpit first.": "مزامنة المنصة غير مُعدّة بعد. احفظ إعداداتها في مركز التكامل أولًا.",
    "The platform sync is running. Try again when it has finished.": "مزامنة المنصة قيد التشغيل. حاول مرة أخرى عند انتهائها.",
    "The platform sync is switched off.": "مزامنة المنصة معطّلة.",
    "The platform sync settings are incomplete.": "إعدادات مزامنة المنصة غير مكتملة.",
    "The platform's feed, at an address": "مصدر المنصة، على عنوان",
    "The price could not be saved.": "تعذّر حفظ السعر.",
    "The programme": "البرنامج",
    "The programme could not be changed.": "تعذّر تغيير البرنامج.",
    "The project list could not be loaded. Reconnect to start a new lesson.": "تعذّر تحميل قائمة المشاريع. أعد الاتصال لبدء درس جديد.",
    "The push settings could not be saved.": "تعذّر حفظ إعدادات الإشعارات الفورية.",
    "The push signing key is generated here, not entered.": "مفتاح توقيع الإشعارات الفورية يُنشأ هنا، ولا يُدخَل.",
    "The question could not be added.": "تعذّرت إضافة السؤال.",
    "The record as the platform sent it": "السجل كما أرسلته المنصة",
    "The reference number is issued when this first reaches the server.": "يصدر الرقم المرجعي عندما يصل هذا إلى الخادم لأول مرة.",
    "The report could not be issued.": "تعذّر إصدار التقرير.",
    "The report could not be run.": "تعذّر تشغيل التقرير.",
    "The response could not be archived.": "تعذّرت أرشفة الرد.",
    "The response could not be saved.": "تعذّر حفظ الرد.",
    "The rewrite could not be requested.": "تعذّر طلب إعادة الصياغة.",
    "The same department is listed twice.": "الإدارة نفسها مذكورة مرتين.",
    "The setup token is required.": "رمز الإعداد مطلوب.",
    "The sign-in settings could not be saved.": "تعذّر حفظ إعدادات تسجيل الدخول.",
    "The sync could not be run.": "تعذّر تشغيل المزامنة.",
    "The sync settings could not be saved.": "تعذّر حفظ إعدادات المزامنة.",
    "The team could not be saved.": "تعذّر حفظ الفريق.",
    "The test could not be run.": "تعذّر تشغيل الاختبار.",
    "The thresholds escalation compares against — “closure rate below target for 2 consecutive months” uses the target set here.": "العتبات التي يقارن بها التصعيد — «نسبة إغلاق أقل من المستهدف لشهرين متتاليين» تستخدم المستهدف المحدد هنا.",
    "The time the meeting was": "الوقت الذي عُقد فيه الاجتماع",
    "The token could not be stored.": "تعذّر تخزين الرمز.",
    "The toolbox talks could not be saved.": "تعذّر حفظ الاجتماعات التوعوية.",
    "The uploaded data could not be decoded.": "تعذّر فك ترميز البيانات المرفوعة.",
    "The uploaded file could not be decoded.": "تعذّر فك ترميز الملف المرفوع.",
    "The uploaded file is empty.": "الملف المرفوع فارغ.",
    "The wording could not be saved.": "تعذّر حفظ الصياغة.",
    "The workbook could not be read.": "تعذّرت قراءة المصنف.",
    "The workbook matches what is already recorded. Nothing to import.": "المصنف يطابق ما هو مسجل بالفعل. لا شيء للاستيراد.",
    "The working calendar could not be saved.": "تعذّر حفظ تقويم العمل.",
    "The year’s programme: each planned audit, its dates, and how far it has got.": "برنامج السنة: كل تدقيق مخطط، وتواريخه، وإلى أين وصل.",
    "There are no Guest Auditor accounts yet. An access administrator creates one in Users & roles.": "لا توجد حسابات مدققين زائرين بعد. ينشئ مسؤول الصلاحيات حسابًا في المستخدمون والأدوار.",
    "There is no connector of that type.": "لا يوجد موصّل من هذا النوع.",
    "There is no extension request on this corrective action.": "لا يوجد طلب تمديد على هذا الإجراء التصحيحي.",
    "There is no message with that key.": "لا توجد رسالة بذلك المفتاح.",
    "These always reach you, whatever you choose above:": "تصلك هذه دائمًا، مهما اخترت أعلاه:",
    "These settings apply to this application only. Changing them does not affect the other two.": "تنطبق هذه الإعدادات على هذا التطبيق فقط. تغييرها لا يؤثر في التطبيقين الآخرين.",
    "This account signs in through the Algihaz platform and has no QMS360 password to reset.": "يسجّل هذا الحساب الدخول عبر منصة Algihaz ولا توجد له كلمة مرور في QMS360 لإعادة تعيينها.",
    "This account signs in through the Algihaz platform and has no QMS360 password.": "يسجّل هذا الحساب الدخول عبر منصة Algihaz ولا توجد له كلمة مرور في QMS360.",
    "This application has no AI features yet.": "لا توجد ميزات ذكاء اصطناعي في هذا التطبيق بعد.",
    "This audit cannot be closed yet.": "لا يمكن إغلاق هذا التدقيق بعد.",
    "This audit could not be closed.": "تعذّر إغلاق هذا التدقيق.",
    "This audit is already closed.": "هذا التدقيق مغلق بالفعل.",
    "This audit is closed, so nobody new can be invited to read it.": "هذا التدقيق مغلق، لذا لا يمكن دعوة أحد جديد لقراءته.",
    "This audit is closed. A new finding needs a follow-up audit.": "هذا التدقيق مغلق. الملاحظة الجديدة تحتاج إلى تدقيق متابعة.",
    "This audit is closed. Evidence cannot be added to it.": "هذا التدقيق مغلق. لا يمكن إضافة أدلة إليه.",
    "This audit is closed. Reopening it is a deliberate act, not an edit.": "هذا التدقيق مغلق. إعادة فتحه إجراء مقصود، لا تعديل.",
    "This audit is not open to you": "هذا التدقيق غير متاح لك",
    "This corrective action cannot be submitted yet.": "لا يمكن تقديم هذا الإجراء التصحيحي بعد.",
    "This corrective action is closed. An extension would change nothing.": "هذا الإجراء التصحيحي مغلق. التمديد لن يغيّر شيئًا.",
    "This corrective action is with the auditor for verification. It cannot be edited until it comes back.": "هذا الإجراء التصحيحي لدى المدقق للتحقق. لا يمكن تعديله حتى يعود.",
    "This finding is closed. A new corrective action needs it reopened.": "هذه الملاحظة مغلقة. الإجراء التصحيحي الجديد يحتاج إلى إعادة فتحها.",
    "This finding is closed. Reopening it is a deliberate act, not an edit.": "هذه الملاحظة مغلقة. إعادة فتحها إجراء مقصود، لا تعديل.",
    "This has happened before": "حدث هذا من قبل",
    "This is recorded as non-conforming but no finding has been raised. The audit cannot be closed until one is.": "سُجّل هذا على أنه غير مطابق لكن لم تُسجَّل ملاحظة. لا يمكن إغلاق التدقيق حتى تُسجَّل.",
    "This lesson cannot be submitted yet.": "لا يمكن تقديم هذا الدرس بعد.",
    "This log entry cannot be submitted yet.": "لا يمكن تقديم هذا السجل بعد.",
    "This non-conformity already has corrective action, so it cannot be reclassified as an observation or conformity.": "لعدم المطابقة هذه إجراء تصحيحي بالفعل، لذا لا يمكن إعادة تصنيفها كملاحظة أو مطابقة.",
    "This photo has as many marks as it can keep. Undo some to draw more.": "تحمل هذه الصورة أقصى عدد من العلامات. تراجع عن بعضها لترسم المزيد.",
    "This plan cannot be shared yet.": "لا يمكن مشاركة هذه الخطة بعد.",
    "This record belongs to another organisation.": "هذا السجل يخص منظمة أخرى.",
    "This report cannot be submitted yet.": "لا يمكن تقديم هذا التقرير بعد.",
    "This report could not be opened.": "تعذّر فتح هذا التقرير.",
    "This schedule cannot be submitted yet.": "لا يمكن تقديم هذا الجدول بعد.",
    "This server is already set up. First-run setup closes for good once an organisation exists.": "هذا الخادم مُعدّ بالفعل. يُغلق الإعداد الأولي نهائيًا بمجرد وجود منظمة.",
    "Those figures could not be saved.": "تعذّر حفظ تلك الأرقام.",
    "Those minutes could not be recorded.": "تعذّر تسجيل ذلك المحضر.",
    "Thu": "الخميس",
    "Timed out": "انتهت المهلة",
    "Timeliness": "الالتزام بالمواعيد",
    "Times raised": "مرات التسجيل",
    "Timezone": "المنطقة الزمنية",
    "Title": "العنوان",
    "Title, reference, or anything in the narrative": "العنوان أو المرجع أو أي شيء في النص",
    "To": "إلى",
    "Today’s entry": "سجل اليوم",
    "Took": "استغرق",
    "Tool": "الأداة",
    "Toolbox talk count, attendance and duration.": "عدد الاجتماعات التوعوية والحضور والمدة.",
    "Total": "الإجمالي",
    "Total minutes": "إجمالي الدقائق",
    "Totals per project over a date range — the fortnightly distribution view. Review time is recalculated from the underlying figures, not averaged from daily averages.": "الإجماليات لكل مشروع خلال نطاق تاريخي — عرض التوزيع نصف الشهري. تُعاد حساب مدة المراجعة من الأرقام الأساسية، ولا تُحسب كمتوسط للمتوسطات اليومية.",
    "Try again": "حاول مرة أخرى",
    "Tue": "الثلاثاء",
    "Turn off here": "أوقفه من هنا",
    "Turn on push for this device": "فعّل الإشعارات الفورية لهذا الجهاز",
    "Two people edited the same field, and both versions were kept. Neither has been applied — choose which one this record should hold.": "عدّل شخصان الحقل نفسه، وحُفظت النسختان. لم تُطبَّق أي منهما — اختر ما يجب أن يحمله هذا السجل.",
    "Type": "النوع",
    "Type the text first, then tap where it goes.": "اكتب النص أولًا، ثم انقر حيث يوضع.",
    "Unanswered": "دون إجابة",
    "Unavailable": "غير متاح",
    "Under review": "قيد المراجعة",
    "Undo": "تراجع",
    "Unknown application": "تطبيق غير معروف",
    "Unknown application.": "تطبيق غير معروف.",
    "Unknown provider.": "مزوّد غير معروف.",
    "Unread only": "غير المقروء فقط",
    "Until": "حتى",
    "Until (the end of that day)": "حتى (نهاية ذلك اليوم)",
    "Usage": "الاستخدام",
    "Usage and adoption": "الاستخدام والتبنّي",
    "Use this one": "استخدم هذه",
    "User": "المستخدم",
    "User directory": "دليل المستخدمين",
    "User directory, role builder, permission matrix and delegation register.": "دليل المستخدمين، ومنشئ الأدوار، ومصفوفة الصلاحيات، وسجل التفويضات.",
    "User name (empty if the server needs none)": "اسم المستخدم (فارغ إن لم يحتج الخادم إليه)",
    "Username": "اسم المستخدم",
    "Users & Roles": "المستخدمون والأدوار",
    "Users & roles": "المستخدمون والأدوار",
    "Using the default mapping.": "يُستخدم التعيين الافتراضي.",
    "Using the key in the server’s configuration.": "يُستخدم المفتاح الموجود في إعدادات الخادم.",
    "Validate": "تحقّق",
    "Value": "القيمة",
    "Verification:": "التحقق:",
    "Verified": "تم التحقق",
    "Version {0}.": "الإصدار {0}.",
    "View All": "عرض الكل",
    "View Own": "عرض الخاص",
    "Waiting for a decision": "بانتظار قرار",
    "Waiting to sync": "بانتظار المزامنة",
    "Wed": "الأربعاء",
    "Weights were re-normalised across the": "أُعيد توزيع الأوزان على",
    "What": "ماذا",
    "What and where": "ماذا وأين",
    "What needs changing": "ما الذي يحتاج إلى تغيير",
    "What needs changing?": "ما الذي يحتاج إلى تغيير؟",
    "What needs to change? Required — a verdict is not a correction.": "ما الذي يجب تغييره؟ مطلوب — الحكم ليس تصحيحًا.",
    "What reminders, overdue notices and escalations say. Changing the wording takes effect from the next message.": "ما تقوله التذكيرات وإشعارات التأخير والتصعيدات. يسري تغيير الصياغة من الرسالة التالية.",
    "What the audit reports count. A nonconformity against the same clause in the same department within the window is a recurrence; open corrective actions are grouped by age into the bands.": "ما تحسبه تقارير التدقيق. عدم المطابقة مقابل البند نفسه في الإدارة نفسها خلال النافذة يُعدّ تكرارًا؛ وتُجمَّع الإجراءات التصحيحية المفتوحة حسب عمرها في الفئات.",
    "What this report cannot show": "ما لا يستطيع هذا التقرير إظهاره",
    "What was found": "ما الذي وُجد",
    "What will change": "ما الذي سيتغير",
    "What you observed": "ما شاهدته",
    "What you observed — required to mark this non-conforming": "ما شاهدته — مطلوب لوسم هذا بعدم المطابقة",
    "What you verified — required either way": "ما تحققت منه — مطلوب في الحالتين",
    "When": "متى",
    "When approved": "عند الاعتماد",
    "Where": "أين",
    "Where the list is in the response (dot path; empty = the whole response)": "موضع القائمة في الاستجابة (مسار نقطي؛ فارغ = الاستجابة كاملة)",
    "Which AI service this application uses. None is switched on until someone chooses one here.": "خدمة الذكاء الاصطناعي التي يستخدمها هذا التطبيق. لا يُفعَّل أي منها حتى يختاره أحد هنا.",
    "Which field in the platform's feed fills each QMS360 field, as a name or a dot path (for example": "أي حقل في مصدر المنصة يملأ كل حقل في QMS360، كاسم أو مسار نقطي (مثلًا",
    "Which records": "أي السجلات",
    "Whichever you choose is recorded against this record.": "أيًّا كان اختيارك يُسجَّل على هذا السجل.",
    "Whichever you choose, both versions stay in the audit log — including the one you did not keep.": "أيًّا كان اختيارك، تبقى النسختان في سجل التدقيق — بما فيها التي لم تحتفظ بها.",
    "Who": "من",
    "Who gets chased, after how long, and at what priority. Every number here can be changed on this screen.": "من تُجرى متابعته، وبعد كم من الوقت، وبأي أولوية. يمكن تغيير كل رقم هنا من هذه الشاشة.",
    "Who is currently acting for whom, and until when. One click ends any of them — most obviously when the delegator is the person who is away.": "من ينوب عن من حاليًا، وحتى متى. نقرة واحدة تنهي أيًّا منها — وأوضح الحالات عندما يكون المفوِّض هو الغائب.",
    "Who receives generated reports, and on what cadence.": "من يستلم التقارير المُنشأة، وبأي وتيرة.",
    "Why": "السبب",
    "Why set it aside": "سبب التنحية",
    "Working calendar": "تقويم العمل",
    "Working offline.": "العمل دون اتصال.",
    "Working…": "جارٍ العمل…",
    "Workspace role": "دور مساحة العمل",
    "Write something first.": "اكتب شيئًا أولًا.",
    "Write something in this field before asking for a rewrite.": "اكتب شيئًا في هذا الحقل قبل طلب إعادة الصياغة.",
    "Write the checklists auditors work through, question by question.": "اكتب قوائم التحقق التي يعمل عليها المدققون، سؤالًا بعد سؤال.",
    "Writing checklists needs configuration authority in QMS Audit.": "كتابة قوائم التحقق تحتاج إلى صلاحية الإعداد في تدقيق نظام إدارة الجودة.",
    "Written": "مكتوب",
    "Written once and chosen on each audit. Questions are added in order; one already answered on an audit stays as it was asked.": "تُكتب مرة واحدة وتُختار في كل تدقيق. تُضاف الأسئلة بالترتيب؛ والسؤال الذي أُجيب عنه في تدقيق يبقى كما طُرح.",
    "Year": "السنة",
    "Yes, end it": "نعم، أنهِه",
    "Yes, reset": "نعم، أعد التعيين",
    "Yes, retire it": "نعم، أوقفه",
    "You are not allowed to open this document: it contains a record your role cannot see.": "لا يُسمح لك بفتح هذا المستند: فيه سجل لا يسمح لك دورك برؤيته.",
    "You are not invited to any open audit at the moment. Your invitation may have ended, or the audit has closed.": "لست مدعوًا إلى أي تدقيق مفتوح في الوقت الحالي. ربما انتهت دعوتك، أو أُغلق التدقيق.",
    "You can reach this application, but no modules are available until you are given a role in it. Ask your administrator for access.": "يمكنك الوصول إلى هذا التطبيق، لكن لا تتوفر أي وحدات حتى يُمنح لك دور فيه. اطلب الصلاحية من مسؤولك.",
    "You can read these until your invitation ends or the audit closes. What you open is recorded.": "يمكنك قراءة هذه حتى تنتهي دعوتك أو يُغلق التدقيق. ما تفتحه يُسجَّل.",
    "You can see entries for {0}. Sign-ins and access changes are for access administrators.": "يمكنك رؤية سجلات {0}. تسجيلات الدخول وتغييرات الصلاحيات لمسؤولي الصلاحيات.",
    "You can see every entry, including sign-ins and access changes.": "يمكنك رؤية كل السجلات، بما فيها تسجيلات الدخول وتغييرات الصلاحيات.",
    "You can see these connections but not change them: they are shared by all three applications, so changing one needs integration authority in all three.": "يمكنك رؤية هذه الاتصالات دون تغييرها: إنها مشتركة بين التطبيقات الثلاثة، لذا يحتاج تغيير أي منها إلى صلاحية التكامل في الثلاثة.",
    "You cannot change your own roles. Ask another administrator, so the change has somebody else’s name on it.": "لا يمكنك تغيير أدوارك بنفسك. اطلب من مسؤول آخر، ليحمل التغيير اسم شخص آخر.",
    "You cannot delegate your authority to yourself.": "لا يمكنك تفويض صلاحيتك لنفسك.",
    "You cannot reset your own password here. Use Change password, which asks for your current one.": "لا يمكنك إعادة تعيين كلمة مرورك من هنا. استخدم تغيير كلمة المرور، الذي يطلب كلمتك الحالية.",
    "You hand over": "تسلّم",
    "You have not given or received a delegation.": "لم تمنح تفويضًا ولم تستلم أيًّا.",
    "You requested this extension, so somebody else approves it.": "أنت من طلب هذا التمديد، لذا يعتمده شخص آخر.",
    "You submitted this corrective action, so it needs a different verifier. This keeps the verification independent.": "أنت من قدّم هذا الإجراء التصحيحي، لذا يحتاج إلى متحقِّق آخر. هذا يحفظ استقلالية التحقق.",
    "You submitted this corrective action, so somebody else approves its extension.": "أنت من قدّم هذا الإجراء التصحيحي، لذا يعتمد تمديده شخص آخر.",
    "You submitted this lesson, so it needs a different approver. This keeps the approval independent.": "أنت من قدّم هذا الدرس، لذا يحتاج إلى معتمِد آخر. هذا يحفظ استقلالية الاعتماد.",
    "You submitted this log entry, so it needs a different approver. This keeps the approval independent.": "أنت من قدّم هذا السجل، لذا يحتاج إلى معتمِد آخر. هذا يحفظ استقلالية الاعتماد.",
    "You submitted this report, so it needs a different approver. This keeps the approval independent.": "أنت من قدّم هذا التقرير، لذا يحتاج إلى معتمِد آخر. هذا يحفظ استقلالية الاعتماد.",
    "You submitted this schedule, so it needs a different approver. This keeps the approval independent.": "أنت من قدّم هذا الجدول، لذا يحتاج إلى معتمِد آخر. هذا يحفظ استقلالية الاعتماد.",
    "Your account signs in through the Algihaz platform, so it has no QMS360 password to change.": "يسجّل حسابك الدخول عبر منصة Algihaz، لذا لا توجد له كلمة مرور في QMS360 لتغييرها.",
    "Your audits": "عمليات التدقيق الخاصة بك",
    "Your audits could not be loaded.": "تعذّر تحميل عمليات التدقيق الخاصة بك.",
    "Your current password is not correct.": "كلمة مرورك الحالية غير صحيحة.",
    "Your delegations could not be loaded.": "تعذّر تحميل تفويضاتك.",
    "Your invitation may have ended, or the audit has closed.": "ربما انتهت دعوتك، أو أُغلق التدقيق.",
    "Your messages could not be marked read.": "تعذّر تعليم رسائلك كمقروءة.",
    "Your name, designation and signature are attached automatically at submission — they are taken from your user record, never typed here.": "يُرفق اسمك ومسمّاك الوظيفي وتوقيعك تلقائيًا عند التقديم — تُؤخذ من سجل المستخدم الخاص بك، ولا تُكتب هنا أبدًا.",
    "Your notifications could not be loaded.": "تعذّر تحميل إشعاراتك.",
    "Your password could not be changed.": "تعذّر تغيير كلمة مرورك.",
    "Your preferences could not be saved.": "تعذّر حفظ تفضيلاتك.",
    "Your role does not include configuration authority in this application.": "لا يتضمن دورك صلاحية الإعداد في هذا التطبيق.",
    "Your role does not include ending delegations.": "دورك لا يتضمن إنهاء التفويضات.",
    "Your role does not let you edit this lesson.": "دورك لا يسمح لك بتعديل هذا الدرس.",
    "Your roles allow {0} in {1}, but not for this record's business unit or project.": "أدوارك تسمح بـ{0} في {1}، لكن ليس لوحدة الأعمال أو المشروع الخاص بهذا السجل.",
    "Your roles do not allow changing master data in any application.": "أدوارك لا تسمح بتغيير البيانات الرئيسية في أي تطبيق.",
    "Your roles do not allow managing integrations in any application.": "أدوارك لا تسمح بإدارة التكاملات في أي تطبيق.",
    "Your roles do not allow {0} in {1}.": "أدوارك لا تسمح بـ{0} في {1}.",
    "a former colleague": "زميل سابق",
    "accepted by the mail server for {0}": "قبله خادم البريد لـ {0}",
    "active": "نشط",
    "ai-settings": "ai-settings",
    "an unnamed user": "مستخدم دون اسم",
    "and 64. The floor of": "و64. الحد الأدنى",
    "answered": "تمت الإجابة",
    "approving or sending back": "الاعتماد أو الإعادة للمراجعة",
    "attributes.projectCode": "attributes.projectCode",
    "audit-log": "audit-log",
    "by the author.": "من قِبل الكاتب.",
    "change": "تغيير",
    "change is": "تغيير",
    "changes": "تغييرات",
    "changes are": "تغييرات",
    "changing configuration": "تغيير الإعدادات",
    "clause": "البند",
    "closure_rate": "closure_rate",
    "configure_masters": "configure_masters",
    "corrective action": "إجراء تصحيحي",
    "could not be used.": "تعذّر استخدامه.",
    "created": "أُنشئ",
    "creating or editing records": "إنشاء السجلات أو تعديلها",
    "data-sync": "data-sync",
    "data.items": "data.items",
    "delegating": "التفويض",
    "distribution": "distribution",
    "e.g. Formwork rework on Project Alpha — root cause was late drawing approval, moderate severity, negative impact.": "مثلًا: إعادة عمل القوالب في مشروع ألفا — السبب الجذري تأخر اعتماد المخططات، خطورة متوسطة، أثر سلبي.",
    "e.g. Minor non-conformity against clause 7.5.3, medium risk: superseded drawings in use at level 3.": "مثلًا: عدم مطابقة بسيطة مقابل البند 7.5.3، مخاطر متوسطة: استخدام مخططات ملغاة في المستوى 3.",
    "e.g. Today on Project Alpha: 12 submittals, 3 drawings, 10 approved, 2 rejected, 3 under review.": "مثلًا: اليوم في مشروع ألفا: 12 تقديمًا، 3 مخططات، 10 معتمدة، 2 مرفوضة، 3 قيد المراجعة.",
    "e.g. approve": "مثلًا: approve",
    "e.g. approver_reviewer": "مثلًا: approver_reviewer",
    "email(s) not sent or failed.": "رسالة بريد إلكتروني لم تُرسل أو فشلت.",
    "escalation-matrix": "escalation-matrix",
    "every finding resolved": "كل الملاحظات مُعالجة",
    "expired": "منتهي الصلاحية",
    "exporting": "التصدير",
    "failed": "فشل",
    "figures changed.": "رقمًا تغيّر.",
    "finding": "ملاحظة",
    "generated": "أُنشئ",
    "held": "محتفظ به",
    "in scope,": "ضمن النطاق،",
    "in the feed:": "في المصدر:",
    "integrations": "integrations",
    "is a record, not an action: it carries no corrective action and needs no closing.": "سجل وليس إجراءً: لا يحمل إجراءً تصحيحيًا ولا يحتاج إلى إغلاق.",
    "is fixed.": "ثابت.",
    "issued,": "صادر،",
    "items answered,": "بندًا تمت الإجابة عنه،",
    "job monitor": "مراقب المهام",
    "last seen {0}": "آخر ظهور {0}",
    "line": "سطر",
    "mailto:it@example.com": "mailto:it@example.com",
    "manage_ai_settings": "manage_ai_settings",
    "manage_integrations": "manage_integrations",
    "managing AI settings": "إدارة إعدادات الذكاء الاصطناعي",
    "managing integrations": "إدارة التكاملات",
    "master-data": "master-data",
    "meeting": "اجتماع",
    "ms · tokens": "مللي ثانية · رموز",
    "need reconciling": "تحتاج إلى تسوية",
    "needs reconciling": "يحتاج إلى تسوية",
    "never signed in": "لم يسجّل الدخول قط",
    "next request": "الطلب التالي",
    "non-conforming with no finding raised": "غير مطابق دون تسجيل ملاحظة",
    "non-conforming.": "غير مطابق.",
    "not costed": "دون تكلفة",
    "not generated yet": "لم يُنشأ بعد",
    "not sent ·": "غير مرسل ·",
    "not stored": "غير مخزَّن",
    "of": "من",
    "off": "معطّل",
    "on behalf of": "نيابة عن",
    "on record. Approved reports keep pointing at the one that produced them.": "مسجلة. تبقى التقارير المعتمدة مرتبطة بالإصدار الذي أنتجها.",
    "one address per line": "عنوان واحد في كل سطر",
    "only. The Quality Index always spans every category, so it is unaffected by this filter.": "فقط. يشمل مؤشر الجودة كل الفئات دائمًا، لذا لا يتأثر بعامل التصفية هذا.",
    "periods are below the": "فترات أقل من",
    "photos": "صور",
    "project(s) were made in QMS360 and are not linked to the platform.": "مشروعًا/مشاريع أُنشئت في QMS360 وغير مرتبطة بالمنصة.",
    "provisional": "مؤقتة",
    "pts": "نقطة",
    "qms360@example.com": "qms360@example.com",
    "queued ·": "في الانتظار ·",
    "rbac": "rbac",
    "recipient": "مستلم",
    "response": "رد",
    "responses": "ردود",
    "revoked": "مسحوب",
    "risk": "المخاطر",
    "roles in one application for a period — the person acting holds them, narrowed to what you tick, until the end date. It is recorded against your name.": "أدوارك في تطبيق واحد لمدة محددة — يحملها النائب، مقتصرة على ما تحدده، حتى تاريخ الانتهاء. يُسجَّل ذلك باسمك.",
    "runs outside Algihaz. The figures used for each suggestion are sent to it. Algihaz has not yet confirmed which providers are permitted, so switching this on is a decision that is recorded under your name.": "يعمل خارج Algihaz. تُرسل إليه الأرقام المستخدمة في كل اقتراح. لم تؤكد Algihaz بعد المزوّدين المسموح بهم، لذا فإن تفعيل هذا قرار يُسجَّل باسمك.",
    "shipped — not editable; build a custom role beside it": "مرفق — غير قابل للتعديل؛ أنشئ دورًا مخصصًا إلى جانبه",
    "smtp.example.com": "smtp.example.com",
    "still open. A finding closes only when every one of its corrective actions is verified effective.": "لا تزال مفتوحة. لا تُغلق الملاحظة إلا عندما يُتحقق من فعالية كل إجراءاتها التصحيحية.",
    "still open. Each is listed under the finding it came from.": "لا تزال مفتوحة. كلٌّ منها مدرج تحت الملاحظة التي نشأ منها.",
    "stored, ending …": "مخزَّن، ينتهي بـ …",
    "stored, ending …{0}": "مخزَّن، ينتهي بـ …{0}",
    "submitting": "التقديم",
    "the server would not accept. Nothing has been discarded; correct the lesson and it is sent again.": "لم يقبلها الخادم. لم يُتجاهل شيء؛ صحّح الدرس وسيُرسل مرة أخرى.",
    "time": "وقت",
    "to": "إلى",
    "to see what is outstanding and act on it.": "لرؤية ما هو معلّق والتصرف بشأنه.",
    "tried": "جُرّب",
    "unchanged,": "دون تغيير،",
    "updated": "حُدِّث",
    "useSession must be used inside a SessionProvider.": "يجب استخدام useSession داخل SessionProvider.",
    "username,roleKey,businessUnitCodes,projectCodes,expiresAt\nrami,form_creator,CONST,ALPHA;BETA,": "username,roleKey,businessUnitCodes,projectCodes,expiresAt\nrami,form_creator,CONST,ALPHA;BETA,",
    "valid,": "صالح،",
    "var(--tone-critical)": "var(--tone-critical)",
    "var(--tone-neutral)": "var(--tone-neutral)",
    "var(--tone-pending)": "var(--tone-pending)",
    "var(--tone-positive)": "var(--tone-positive)",
    "version": "الإصدار",
    "view_all": "view_all",
    "viewing everyone’s records": "عرض سجلات الجميع",
    "viewing records": "عرض السجلات",
    "waiting on this device": "بانتظار الإرسال على هذا الجهاز",
    "went to": "ذهب إلى",
    "with problems.": "فيها مشكلات.",
    "would be created": "سيُنشأ",
    "would be updated": "سيُحدَّث",
    "yet.": "بعد.",
    "your own": "الخاصة بك",
    "{0} ({1} open)": "{0} ({1} مفتوحة)",
    "{0} API key": "مفتاح الواجهة البرمجية لـ {0}",
    "{0} Your entry is saved on this device and will retry.": "{0} حُفظ إدخالك على هذا الجهاز وستُعاد المحاولة.",
    "{0} after {1} days, to {2}": "{0} بعد {1} يومًا، إلى {2}",
    "{0} audit{1} planned.": "{0} تدقيق{1} مخطط.",
    "{0} for {1}": "{0} لـ {1}",
    "{0} grant(s)": "{0} منحة/منح",
    "{0} mark{1}.": "{0} علامة{1}.",
    "{0} not found.": "لم يُعثر على {0}.",
    "{0} open": "{0} مفتوح",
    "{0} photo": "صورة {0}",
    "{0} photo waiting to sync": "صورة {0} بانتظار المزامنة",
    "{0} photo{1} still waiting to upload from this device. Submit once {2} gone — nothing has been lost.": "{0} صورة{1} لا تزال بانتظار الرفع من هذا الجهاز. قدّم بعد أن {2} رُفعت — لم يُفقد شيء.",
    "{0} to {1}": "{0} إلى {1}",
    "{0}, with {1}": "{0}، مع {1}",
    "{0}: {1} of {2}": "{0}: {1} من {2}",
    "· dry run": "· تشغيل تجريبي",
    "· generated": "· أُنشئ",
    "· reaches": "· يشمل",
    "· read-only": "· للقراءة فقط",
    "· until": "· حتى",
    "— nobody has to sign out, because authority is read from here every time rather than carried in a token.": "— لا يحتاج أحد إلى تسجيل الخروج، لأن الصلاحية تُقرأ من هنا في كل مرة ولا تُحمل في رمز.",
    "— not granted": "— غير ممنوح",
    "— not set up on this server yet": "— غير مُعدّ على هذا الخادم بعد",
    "— sealed under a key this server no longer has; enter it again": "— مختوم بمفتاح لم يعد لدى هذا الخادم؛ أدخله مرة أخرى",
    "— shown once. They must choose a new one when they sign in": "— تُعرض مرة واحدة. يجب عليه اختيار كلمة جديدة عند تسجيل الدخول",
    "— these numbers are ours, not Algihaz’s. Every PQI on screen carries that badge until Algihaz confirms them.": "— هذه الأرقام من عندنا، لا من Algihaz. يحمل كل مؤشر جودة على الشاشة تلك الشارة حتى تؤكدها Algihaz.",
    "’s password? This signs them out everywhere.": "؟ هذا يسجّل خروجه من كل مكان.",
    "“Not effective” is a finished corrective action that did not work. It closes this one and leaves the finding open for a follow-up.": "«غير فعّال» إجراء تصحيحي مكتمل لم ينجح. يُغلق هذا الإجراء ويُبقي الملاحظة مفتوحة للمتابعة.",
};
//# sourceMappingURL=ar.js.map